export const translations = {
  en: {
    // ==================== NAVBAR ====================
    nav: {
      platform: 'Platform',
      solutions: 'Solutions',
      use_cases: 'Use Cases',
      connectors: 'Connectors',
      pricing: 'Pricing',
      resources: 'Resources',
      free_trial: 'Free Trial',
      sign_in: 'Sign in',
      // Solutions dropdown
      sol_data_eng: 'Data Engineering',
      sol_pipelines: 'Data Pipelines & ETL',
      sol_pipelines_desc: 'Visual workflow builder with Python support',
      sol_transformer: 'AI Data Transformer',
      sol_transformer_badge: 'New',
      sol_transformer_desc: 'Smart schema mapping & data cleansing',
      sol_analytics: 'AI & Analytics',
      sol_analytics_desc: 'AutoML, forecasting & anomaly detection',
      sol_dashboards: 'Dashboards & APIs',
      sol_dashboards_desc: 'Real-time visualization & REST endpoints',
      sol_platform: 'Platform',
      sol_connectors: '100+ Connectors',
      sol_connectors_desc: 'Databases, APIs, IoT protocols',
      sol_infra: 'Infrastructure',
      sol_infra_desc: 'Self-hosted or Swiss cloud',
      sol_pricing: 'Pricing',
      sol_pricing_desc: 'Flexible plans for teams',
      // Resources dropdown
      res_about: 'About',
      res_security: 'Security',
      res_blog: 'Blog',
      res_contact: 'Contact',
    },

    // ==================== FOOTER ====================
    footer: {
      tagline: 'Effortless Innovation.',
      copyright: '\u00a9 2026 LOGIBLOX AG. All rights reserved.',
      overview: 'OVERVIEW',
      why: 'Why Logiblox?',
      smart_analytics: 'Smart Analytics Platform',
      capabilities: 'Platform Capabilities',
      consulting: 'Data Science & AI Consulting',
      partners: 'Partner Program',
      products: 'PRODUCTS',
      ai_cleanser: 'AI Data Cleanser',
      flow: 'Flow',
      data_analytics: 'Data Analytics',
      app_builder: 'App Builder',
      ai: 'AI',
      pricing_features: 'Pricing & Features',
      solutions_resources: 'SOLUTIONS & RESOURCES',
      by_use_case: 'By Use Case',
      by_role: 'By Role / Function',
      by_industry: 'By Industry',
      data_connectors: 'Data Connectors',
      training: 'Training',
      security: 'Security',
      company_legal: 'Company & Legal',
      about_us: 'About Us',
      careers: 'Careers',
      privacy: 'Data Privacy',
      terms: 'Terms & Conditions',
      imprint: 'Imprint',
      cookie_text: 'We use cookies to enhance your browsing experience and provide you with personalized content.',
      cookie_learn: 'Learn More',
    },

    // ==================== COMMON / SHARED ====================
    common: {
      learn_more: 'Learn more',
      read_more: 'Read more',
      go_back: 'Go Back',
      start_free_trial: 'Start Free Trial',
      view_pricing: 'View Pricing',
      request_demo: 'Request a Demo',
      book_demo: 'Book a Demo',
      register_free: 'Register Free',
      contact_us: 'Contact Us',
      see_pricing: 'See AI Box Pricing',
      order_ai_box: 'Order AI Box',
      view_cloud_plans: 'View Cloud Plans',
      explore_connectors: 'Explore Connectors',
      explore_ai: 'Explore AI Features',
      explore_analytics: 'Explore Analytics',
      swiss_made: 'Swiss Made',
      // CTA section
      cta_title: 'Transform Your Organization',
      cta_text: "Prepare to unveil hidden insights from your data and drive innovation throughout your organization. With LOGIBLOX's powerful tools and intuitive interfaces, you can harness the full potential of your information to make informed decisions and optimize performance.",
      cta_btn: 'Free Trial',
    },

    // ==================== HOME PAGE ====================
    home: {
      // Hero
      hero_badge: 'Now Available: LOGIBLOX AI Box',
      hero_title: 'LOGIBLOX AI Box \u2014 <span class="text-primary">On-Premise. Ready to Go.</span>',
      hero_lead: 'The complete LOGIBLOX AI data platform on dedicated hardware. Pre-installed, pre-configured \u2014 plug in and start building data pipelines, running AI models, and automating workflows. Fully on your premises.',
      hero_check1: '<strong>Full data sovereignty</strong> \u2014 runs entirely in your network',
      hero_check2: '<strong>Same full feature set</strong> as the cloud \u2014 100+ connectors, AI, workflows',
      hero_check3: '<strong>Optional maintenance &amp; training subscription</strong> keeps you current',
      hero_price: 'From \u20ac39,999 (platform + hardware) \u00b7 Maintenance optional from \u20ac499/month',
      hero_also_cloud: 'Also available as cloud subscription',
      // Proof bar
      proof_1: 'More Efficient Operations',
      proof_2: 'Faster Development',
      proof_3: 'Cost Savings vs Custom Dev',
      // Deployment
      deploy_title: 'Choose Your Deployment',
      deploy_subtitle: 'Same powerful platform. Your choice of where it runs.',
      deploy_box_badge: 'Recommended for SME',
      deploy_box_title: 'LOGIBLOX AI Box',
      deploy_box_type: 'On-Premise Hardware',
      deploy_box_desc: 'Pre-configured hardware appliance with full LOGIBLOX platform license delivered to your door. Plug into your network and go live in hours. Zero cloud dependency, full data sovereignty.',
      deploy_box_hw: 'Platform + Hardware',
      deploy_box_onetime: 'one-time',
      deploy_box_monthly: 'Optional',
      deploy_box_maint: 'maintenance',
      deploy_box_f1: 'Your network, your data',
      deploy_box_f2: 'No internet dependency',
      deploy_box_f3: 'Ideal for regulated industries',
      deploy_box_f4: 'Software updates & training available',
      deploy_cloud_badge: 'Start in Minutes',
      deploy_cloud_title: 'Cloud Subscription',
      deploy_cloud_type: 'Swiss Data Centers',
      deploy_cloud_desc: 'Hosted on Swiss infrastructure. No hardware, no maintenance \u2014 just log in and start building. GDPR-compliant and production-ready from day one.',
      deploy_cloud_from: 'Starting from',
      deploy_cloud_month: '/month',
      deploy_cloud_trial: '30-day free trial',
      deploy_cloud_f1: 'Swiss data centers, GDPR compliant',
      deploy_cloud_f2: 'No hardware or maintenance',
      deploy_cloud_f3: 'Scale up or down anytime',
      deploy_cloud_f4: '30-day money-back guarantee',
      // Capabilities
      cap_title: 'Everything Your Data Team Needs',
      cap_title2: 'in One Platform',
      cap_subtitle: 'Connect, transform, analyse, and automate \u2014 from raw data to business decisions.',
      cap_connect_title: 'Connect Any Data Source',
      cap_connect_desc: '100+ pre-built connectors for databases, APIs, IoT protocols (MQTT, OPC-UA), cloud services, and file systems. Extend with Python for custom sources.',
      cap_ai_title: 'AI-Powered Automation',
      cap_ai_desc: 'Smart Data Transformer, AutoML, time-series forecasting, anomaly detection, and custom AI model integration. From data to insight \u2014 automatically.',
      cap_insights_title: 'Insights, Apps & APIs',
      cap_insights_desc: 'Build real-time dashboards, internal business apps, and REST APIs \u2014 no frontend code needed. Schedule workflows or trigger via webhook.',
      // Pipeline builder
      pipe_title: 'Visual <span class="text-primary">Data Pipeline Builder</span>',
      pipe_desc: 'Design complex ETL workflows with drag-and-drop. Combine visual components with custom Python scripts. Debug in real-time with step-by-step execution and data previews.',
      // Webinars
      webinar_badge: 'Free Webinars',
      webinar_title: 'Learn from the Experts',
      webinar_subtitle: 'Join our free live webinars to see LOGIBLOX in action. Real use cases, live demos, and Q&A with our engineers.',
      webinar_sql_title: 'Text to SQL',
      webinar_sql_desc: 'Query any database using plain language. See how AI translates business questions into precise SQL \u2014 no query expertise required.',
      webinar_auto_title: 'AI Powered Data Automation',
      webinar_auto_desc: 'Automate your entire data pipeline with AI. From ingestion to transformation to business insights \u2014 fully automated and production-ready.',
      webinar_agents_title: 'AI Agents',
      webinar_agents_desc: 'Build intelligent agents that monitor your data, trigger automated actions, and make decisions autonomously \u2014 the next frontier of data operations.',
      webinar_more_title: 'More Coming Soon',
      webinar_more_desc: 'IoT Analytics, AutoML in Practice, Building REST APIs with No Code, and more real-world use cases.',
      webinar_more_btn: 'Stay Updated',
      // Security
      sec_title: 'Production-Ready Infrastructure',
      sec_desc: 'Deploy on-premise with the AI Box or in Swiss data centers. Built for reliability with enterprise security standards.',
      sec_f1: 'AI Box On-Premise',
      sec_f2: 'High Availability',
      sec_f3: 'End-to-End Encryption',
      sec_f4: 'GDPR Compliant',
      // Consulting
      consult_title: 'Technical Implementation Support',
      consult_desc: 'Need help architecting your data infrastructure? Our engineering team provides hands-on support for complex integrations, custom connector development, and production deployment.',
      // Final CTA
      final_title: 'Ready to Take Control of Your Data?',
      final_desc: 'Start with the AI Box for full on-premise control, or go live in minutes with our cloud plans. Either way, LOGIBLOX gets you there.',
      final_price: 'AI Box from \u20ac39,999 \u00b7 Cloud from \u20ac299/month \u00b7 Swiss Made',
    },

    // ==================== PLATFORM PAGE ====================
    platform: {
      badge: 'All-In-One Platform',
      hero_title: 'Build Data Solutions <span class="text-primary-desat">Without Code</span>',
      hero_desc: 'Enterprise-grade platform to automate workflows, analyze data, deploy AI, and create custom apps\u2014all without technical expertise.',
      hero_f1: '<strong>No coding required</strong> - Build in minutes, not months',
      hero_f2: '<strong>100+ integrations</strong> - Connect all your data sources',
      hero_f3: '<strong>Swiss-hosted</strong> - Enterprise security & GDPR compliant',
      why_title: 'All-in-One Analytics Platform',
      why_desc: 'LOGIBLOX simplifies your processes by integrating everything into a single platform, reducing the need for multiple applications.',
      why_f1: '<strong>50% cost savings</strong> by consolidating tools and improving data consistency',
      why_f2: '<strong>Complete visibility</strong> of business operations for faster decision-making',
      why_f3: '<strong>Seamless scalability</strong> as your organization grows',
      card_automation: 'Automation',
      card_automation_desc: 'Eliminate manual errors and simplify business processes with cutting-edge data automation.',
      card_analytics: 'Analytics',
      card_analytics_desc: 'Process and analyze data, unlock insights, and streamline decision-making with low-code analytics.',
      card_app: 'App Builder',
      card_app_desc: 'Build dashboards and business apps to visualize data and connect with stakeholders seamlessly.',
      card_ai: 'AI & Analytics',
      card_ai_desc: 'Leverage AI to uncover insights hidden in your data with predictive and generative AI capabilities.',
      nav_lowcode: 'LOW-CODE PLATFORM',
      nav_predictive: 'PREDICTIVE ANALYTICS',
      nav_automation: 'AUTOMATION',
      nav_business: 'BUSINESS SOLUTIONS',
      nav_ai: 'AI',
      nav_apis: 'APIS & WORKFLOWS',
      nav_dragdrop: 'DRAG & DROP',
      platform_title: 'LOGIBLOX Low-Code Platform',
      products_title: 'Everything You Need in One Platform',
      products_subtitle: 'Four powerful products working together to transform your data into action',
      view_features: 'View All Features',
      // Media sections
      media1_title: 'LOW-CODE PLATFORM',
      media1_desc: 'Empower your team to create powerful analytics solutions with minimal coding required. Our Low-Code platform makes complex tasks accessible while giving technical users the flexibility to customize and extend functionality as needed.',
      media2_title: 'PREDICTIVE ANALYTICS',
      media2_desc: 'Unlock insights from complex, multi-source data in minutes. Our platform allows you to analyze vast datasets effortlessly, collaborate seamlessly, and share predictions and results, enabling data-driven decisions at speed.',
      media3_title: 'AUTOMATION',
      media3_desc: 'Harness the power of low-code automation to streamline data transformation and operations. Transform complex, distributed datasets into actionable insights with customizable workflows, driving efficiency and clarity.',
      media4_title: 'BUSINESS SOLUTIONS',
      media4_desc: 'Quickly develop dynamic dashboards, cockpits, and other business-critical solutions to supercharge productivity. Implement changes instantly, eliminating the need for IT change requests or delays, and keep your business moving forward.',
      media5_title: 'AI',
      media5_desc: 'Democratize access to AI with low-code solutions that leverage cutting-edge AI engineering, AutoML, and Generative AI technologies. Build advanced AI-driven workflows and applications with minimal coding while maintaining flexibility for customization.',
      media6_title: 'APIS & WORKFLOWS',
      media6_desc: 'Build REST APIs and complex workflows without writing code. Our microservice architecture allows you to create APIs instantly, enabling smooth integration of all necessary data. Tailor processes to fit your unique business requirements.',
      media7_title: 'DRAG & DROP',
      media7_desc: 'Effortlessly design workflows and layouts by simply dragging and dropping BLOX components onto a canvas. This intuitive approach enables you to automate data processes and create intricate designs without technical expertise or coding.',
      // Product cards
      prod_automation_desc: 'LOGIBLOX Automation does the heavylifting for you. Connect your data source and automate data cleansing and curation.',
      prod_analytics_desc: 'LOGIBLOX Analytics enables you to analyze your data right from the start and gain insights in minutes.',
      prod_ai_desc: 'LOGIBLOX AI is a key differentiator giving you prediction superpowers.',
      prod_appbuilder_desc: 'LOGIBLOX App Builder allows you to create dynamic dashboards and complex business apps instantly.',
      // Final CTA
      final_title: 'Ready to Transform Your Data Operations?',
      final_desc: 'Join hundreds of businesses using LOGIBLOX to automate workflows, unlock insights, and accelerate growth. Start your free trial today\u2014no credit card required.',
      final_note: '30-day free trial \u2022 No credit card required \u2022 Cancel anytime',
    },

    // ==================== CONTACT PAGE ====================
    contact: {
      title: 'How can we help?',
      subtitle: "Tell us what you\u2019re looking for \u2014 we\u2019ll get back to you personally within 24 hours.",
      intent_label: 'I want to\u2026',
      demo_title: 'Book a Demo',
      demo_desc: 'See LOGIBLOX in action with one of our engineers',
      trial_title: 'Try the Cloud',
      trial_desc: 'Free 30-day trial, Swiss data centers, no card needed',
      aibox_title: 'Order AI Box',
      aibox_desc: 'On-premise platform + hardware, \u20ac39,999 one-time',
      question_title: 'Ask a Question',
      question_desc: 'Pricing, features, integrations \u2014 we\u2019re happy to help',
      next_title: 'What happens next',
      step1_title: 'We review your request',
      step1_desc: 'Usually within a few hours during business days',
      step2_title: 'A LOGIBLOX engineer contacts you',
      step2_desc: 'Personally \u2014 not an automated sequence',
      step3_title: "You\u2019re up and running",
      step3_desc: 'Cloud trial, live demo, or AI Box delivery \u2014 your choice',
      gdpr_note: 'GDPR compliant \u00b7 End-to-end encrypted',
      response_note: 'Response within 24 hours',
      form_title: 'Get in Touch',
      form_subtitle: "Fill in your details and we\u2019ll be in touch shortly.",
      label_name: 'Name',
      label_email: 'Work Email',
      label_company: 'Company',
      label_phone: 'Phone (Optional)',
      label_message: 'Message (Optional)',
      placeholder_name: 'Your name',
      placeholder_email: 'you@company.com',
      placeholder_company: 'Your company',
      placeholder_phone: '+41 \u2026',
      placeholder_message: 'Tell us about your use case, timeline, or any questions\u2026',
      submit: 'Send Message',
      terms_note: 'By submitting you agree to our',
      terms_link: 'Terms',
      privacy_link: 'Privacy Policy',
    },

    // ==================== ABOUT PAGE ====================
    about: {
      mission: 'Our mission',
      mission_desc: 'At LOGIBLOX, we empower businesses with cutting-edge AI solutions that drive efficiency and unlock new possibilities for growth.',
      what_we_offer: 'What we offer',
      also_pricing: 'Also, take a look at our',
      pricing_link: 'pricing',
      location_title: 'Located in Zurich.',
      location_enjoy: 'Enjoy',
      location_desc: "We picked our office location to maximize our team's productivity! Zurich's proximity to the alps with its vast nature and central location in the heart of Europe, as well as access to world class ETH Zurich University & EPFL. Come visit us and you'll see.",
      stat_quality: 'Swiss Quality',
      stat_trains: 'Trains on time',
      stat_living: 'Quality of living',
      join_title: 'Interested in joining our team?',
      join_desc: "Contact us and we'll get in touch with you.",
      join_btn: 'Apply now',
    },

    // ==================== USE CASES PAGE ====================
    usecases: {
      title: 'LOGIBLOX Use Case Navigator',
      search_placeholder: 'Search',
      discover_intro: 'I would like to discover more about',
      topic: 'Topic',
      all_topics: 'All Topics',
      topic_quality: 'Data Quality',
      topic_transformer: 'Data Transformer',
      topic_automation: 'Data Automation',
      topic_ai_apps: 'AI Apps',
      topic_agentic: 'Agentic AI Apps',
      and_or: 'and/or',
      department: 'Department',
      all_departments: 'All Departments',
      dept_finance: 'Accounting, Finance & Controlling',
      dept_hr: 'Human Resources',
      dept_supply: 'Supply Chain, Logistics & Operations',
      dept_marketing: 'Marketing / Sales',
      dept_rnd: 'Research and Development',
      dept_service: 'Customer Service',
      dept_procurement: 'Procurement',
      dept_it: 'Digital / Information Technology',
      dept_mgmt: 'General Management',
      discover_suffix: 'opportunities with LOGIBLOX',
      discover_btn: 'Discover Use Cases For You',
      great_examples: 'Great Use Case Examples',
      all_features: 'All Products & Features',
    },

    // ==================== PRICING PAGE ====================
    pricing: {
      title: 'Simple, Transparent <span class="text-primary">Pricing</span>',
      subtitle: 'Two ways to run LOGIBLOX \u2014 on your own hardware or in the cloud. Same powerful platform, your choice of deployment.',
      aibox_btn: 'LOGIBLOX AI Box',
      aibox_badge: 'On-Premise',
      cloud_btn: 'Cloud Subscription',
      trial_badge: '30-day free trial on all cloud plans',
      aibox_btn_html: '<i class="fe fe-cpu me-2"></i>LOGIBLOX AI Box <span class="badge bg-white text-primary ms-2">On-Premise</span>',
      cloud_btn_html: '<i class="fe fe-cloud me-2"></i>Cloud Subscription',
      trial_badge_html: '<i class="fe fe-check me-2"></i>30-day free trial on all cloud plans',
      // Cloud plans section
      cloud_badge: '<i class="fe fe-cloud me-2"></i>Cloud Subscription',
      cloud_title: 'Managed Cloud Plans',
      cloud_subtitle: 'Hosted on Swiss data centers. No infrastructure to manage \u2014 start building in minutes.',
      // Starter plan
      starter_name: 'Starter',
      starter_price_suffix: '/month',
      starter_annual: 'Billed annually: \u20ac3,588',
      starter_desc: 'For teams starting their data journey',
      starter_included: "What's included:",
      starter_f1: 'Up to 5 users',
      starter_f2: '10,000 workflow executions/month',
      starter_f3: '50 GB data storage',
      starter_f4: 'Workflow automation',
      starter_f5: 'App & dashboard builder',
      starter_f6: '100+ data connectors',
      starter_f7: 'Advanced analytics',
      starter_f8: 'Smart Data Transformer',
      starter_f9: '1,000 AI operations/month',
      starter_f10: 'Standard support (48h response)',
      starter_btn: 'Start Free Trial',
      // Professional plan
      pro_badge: 'Most Popular',
      pro_name: 'Professional',
      pro_price_suffix: '/month',
      pro_annual: 'Billed annually: \u20ac10,788',
      pro_desc: 'For growing data-driven teams',
      pro_included: 'Starter, plus:',
      pro_workflow_label: 'Workflow Executions:',
      pro_f1: 'Up to 15 users',
      pro_f2: '200 GB data storage',
      pro_f3: 'REST API builder',
      pro_f4: 'Data Quality Manager',
      pro_f5: 'Predictive AI & AutoML',
      pro_f6: '10,000 AI operations/month',
      pro_f7: 'Priority support (24h response)',
      pro_btn: 'Start Free Trial',
      // Enterprise plan
      ent_badge: 'Best Value',
      ent_name: 'Enterprise',
      ent_price_suffix: '/month',
      ent_annual: 'Billed annually: \u20ac35,988',
      ent_desc: 'For enterprise-scale operations',
      ent_included: 'Professional, plus:',
      ent_workflow_label: 'Workflow Executions:',
      ent_f1: 'Up to 50 users',
      ent_f2: '500 GB data storage',
      ent_f3: 'Data model builder',
      ent_f4: '50,000 AI operations/month',
      ent_f5: '99.9% uptime SLA & dedicated support (4h response)',
      ent_btn: 'Start Free Trial',
      // Enterprise Plus plan
      eplus_name: 'Enterprise Plus',
      eplus_price: 'Custom',
      eplus_tailored: 'Tailored to your needs',
      eplus_desc: 'For mission-critical deployments',
      eplus_included: 'Enterprise, plus:',
      eplus_f1: 'Unlimited users',
      eplus_f2: 'Unlimited workflow runs',
      eplus_f3: 'Custom data storage',
      eplus_f4: 'Custom integrations',
      eplus_f5: 'Unlimited AI calls',
      eplus_f6: 'On-premise deployment',
      eplus_f7: '24/7 dedicated support',
      eplus_f8: '99.99% uptime SLA',
      eplus_f9: 'Account manager',
      eplus_f10: 'White label / Custom branding',
      eplus_btn: 'Contact Sales',
      // Compare plans
      compare_title: 'Compare Plans',
      compare_subtitle: 'Detailed feature comparison to help you choose the right plan',
      compare_feature: 'Feature',
      compare_col_foundation: 'Foundation<br><small class="fw-normal text-muted">\u20ac299/mo</small>',
      compare_col_pro: 'Professional<br><small class="fw-normal text-muted">from \u20ac899/mo</small>',
      compare_col_ent: 'Enterprise<br><small class="fw-normal text-muted">from \u20ac2,999/mo</small>',
      compare_col_eplus: 'Enterprise Plus<br><small class="fw-normal text-muted">Custom</small>',
      // Table section headers
      tbl_sec_core: 'Core Platform Limits',
      tbl_sec_automation: 'Automation & Workflows',
      tbl_sec_connectivity: 'Data Connectivity',
      tbl_sec_analytics: 'Analytics & Insights',
      tbl_sec_appbuilder: 'App Builder',
      tbl_sec_apis: 'APIs & Integration',
      tbl_sec_ai: 'AI & Machine Learning',
      tbl_sec_enterprise: 'Enterprise Features',
      tbl_sec_support: 'Support & SLA',
      // Table row headers
      tbl_users: 'Users',
      tbl_workflow_runs: 'Workflow Runs/month',
      tbl_data_storage: 'Data Storage',
      tbl_apps_dashboards: 'Apps & Dashboards',
      tbl_ai_ops: 'AI Operations/month',
      tbl_workflow_automation: 'Workflow Automation',
      tbl_drag_drop_workflow: 'Drag & Drop Workflow Builder',
      tbl_data_transformation: 'Data Transformation',
      tbl_scheduled_workflows: 'Scheduled Workflows',
      tbl_prebuilt_connectors: '100+ Pre-built Connectors',
      tbl_db_connectors: 'Database Connectors (SQL, NoSQL)',
      tbl_cloud_services: 'Cloud Services (AWS, Azure, GCP)',
      tbl_custom_connectors: 'Custom Connectors',
      tbl_basic_analytics: 'Basic Analytics',
      tbl_advanced_analytics: 'Advanced Analytics',
      tbl_custom_dashboards: 'Custom Dashboards',
      tbl_data_viz: 'Data Visualization',
      tbl_drag_drop_app: 'Drag & Drop App Builder',
      tbl_business_apps: 'Business Apps & Forms',
      tbl_white_labeling: 'White Labeling',
      tbl_rest_api: 'REST API Builder',
      tbl_api_mgmt: 'API Management',
      tbl_webhooks: 'Webhooks',
      tbl_smart_transformer: 'Smart Data Transformer (Gen AI)',
      tbl_ai_cleaning: 'AI Data Cleaning & Validation',
      tbl_predictive_ai: 'Predictive AI & AutoML',
      tbl_timeseries: 'Time Series Forecasting',
      tbl_classification: 'Classification & Clustering',
      tbl_feature_eng: 'Automated Feature Engineering',
      tbl_custom_integrations: 'Custom Integrations & Development',
      tbl_onpremise: 'On-Premise Deployment',
      tbl_dedicated_infra: 'Dedicated Infrastructure',
      tbl_support_type: 'Support Type',
      tbl_response_time: 'Response Time',
      tbl_uptime_sla: 'Uptime SLA',
      tbl_training: 'Training & Onboarding',
      // Table cell values
      tbl_up_to_5: 'Up to 5',
      tbl_up_to_15: 'Up to 15',
      tbl_up_to_50: 'Up to 50',
      tbl_unlimited: 'Unlimited',
      tbl_custom: 'Custom',
      tbl_basic: 'Basic',
      tbl_email: 'Email',
      tbl_priority_email: 'Priority Email',
      tbl_priority_live: 'Priority + Live Chat',
      tbl_dedicated_247: '24/7 Dedicated',
      tbl_48h: '48 hours',
      tbl_24h: '24 hours',
      tbl_4h: '4 hours',
      tbl_1h: '1 hour',
      tbl_docs: 'Docs',
      tbl_video_tutorials: 'Video tutorials',
      tbl_live_training: 'Live training',
      tbl_dedicated_onboarding: 'Dedicated onboarding',
      // Guarantee & custom
      guarantee_title: '30-Day Money-Back Guarantee',
      guarantee_desc: "Try any paid plan risk-free. If you're not satisfied within 30 days, get a full refund\u2014no questions asked.",
      custom_title: 'Custom Enterprise Solutions',
      custom_desc: 'Need something specific? We offer tailored solutions with custom features, integrations, and deployment options to fit your exact requirements.',
      // AI Box section
      box_badge: '<i class="fe fe-cpu me-2"></i>On-Premise Hardware',
      box_title: 'LOGIBLOX AI Box',
      box_subtitle: 'The complete LOGIBLOX platform on dedicated hardware. Plug in, connect, and run \u2014 full data sovereignty, zero cloud dependency.',
      box_hw_title: 'AI Box Hardware',
      box_hw_type: 'One-time purchase',
      box_hw_price_desc: 'One-time \u2014 includes full LOGIBLOX platform license, hardware, pre-installation &amp; initial setup',
      box_hw_included: "What's in the box:",
      box_hw_f1: 'Dedicated on-premise hardware appliance',
      box_hw_f2: 'LOGIBLOX pre-installed &amp; pre-configured',
      box_hw_f3: 'Full platform feature set (same as cloud)',
      box_hw_f4: '100+ data connectors',
      box_hw_f5: 'AI &amp; ML capabilities',
      box_hw_f6: 'Visual workflow builder &amp; app designer',
      box_hw_f7: 'On-site installation &amp; initial configuration',
      box_hw_btn: 'Order AI Box <i class="fe fe-arrow-right ms-2"></i>',
      box_maint_addon: 'Optional Add-on',
      box_maint_title: 'Maintenance &amp; Training',
      box_maint_type: 'Optional \u2014 recommended',
      box_maint_monthly: '/month',
      box_maint_annual: 'Annual billing: <strong>\u20ac4,990/year</strong> <span class="badge bg-success-soft text-success ms-1">Save ~17%</span>',
      box_maint_desc: 'Keep your AI Box up-to-date and fully supported',
      box_maint_included: "What's included monthly:",
      box_maint_f1: 'Software updates &amp; security patches',
      box_maint_f2: 'Remote monitoring &amp; health checks',
      box_maint_f3: 'Priority support (24h response)',
      box_maint_f4: 'Training credits (2 sessions/year included)',
      box_maint_f5: 'Connector &amp; feature updates',
      box_maint_f6: 'Hardware warranty &amp; replacement coverage',
      box_maint_f7: 'Access to new AI modules as released',
      box_maint_btn: 'Contact Sales',
      box_vs_cloud_title: 'AI Box vs. Cloud Subscription',
      box_vs_cloud_desc: 'Both offerings include the same full LOGIBLOX platform feature set. Choose the cloud for flexibility and zero infrastructure management. Choose the AI Box for full on-premise control and data sovereignty \u2014 ideal for regulated industries, air-gapped environments, or organisations with strict data residency requirements. Maintenance subscription is optional but recommended to keep your system current.',
      // FAQ section
      faq_title: 'Frequently Asked Questions',
      faq_subtitle: 'Common questions about LOGIBLOX pricing and plans',
      faq1_q: 'What happens when I exceed my plan limits?',
      faq1_a: "We'll notify you when you approach your limits. You can upgrade to a higher tier at any time, and the pricing will be prorated. Your workflows won't stop working\u2014we'll work with you to find the right solution.",
      faq2_q: 'Can I change plans at any time?',
      faq2_a: "Yes! You can upgrade or downgrade your plan at any time. When upgrading, you'll receive prorated credit for your current plan. Downgrades take effect at the start of your next billing cycle.",
      faq3_q: 'How does the 30-day free trial work?',
      faq3_a: "Contact our sales team to discuss a custom trial period tailored to your organization's needs. We offer flexible evaluation options to ensure LOGIBLOX is the right fit for your data operations.",
      faq4_q: 'What payment methods do you accept?',
      faq4_a: 'We accept all major credit cards (Visa, MasterCard, American Express), bank transfers for annual plans, and can arrange invoicing for Enterprise customers.',
      faq5_q: 'Do you offer discounts for annual billing?',
      faq5_a: 'Annual billing is our standard pricing model. Foundation: \u20ac3,588/year, Professional: from \u20ac10,788/year, Enterprise: from \u20ac35,988/year. Monthly billing is available upon request. Contact our sales team for Enterprise Plus custom pricing.',
      faq6_q: 'What are AI calls and how are they used?',
      faq6_a: 'AI operations power intelligent features like Smart Data Transformer (generative AI for data cleaning), predictive analytics, AutoML model training, time series forecasting, and automated data validation. Each AI operation (transformation, prediction, or model training) counts as one operation. Different plans include different monthly allowances: Starter (1,000), Professional (10,000), Enterprise (50,000), and Enterprise Plus (unlimited).',
      faq7_q: 'What kind of support is included?',
      faq7_a: 'Starter includes email support (48h response). Professional adds priority email (24h response) and video tutorials. Business includes priority support with live chat (4h response) and live training. Enterprise gets 24/7 dedicated support (1h response), dedicated onboarding, and a personal account manager.',
      faq8_q: 'What is the LOGIBLOX AI Box and how does it differ from the cloud?',
      faq8_a: "The LOGIBLOX AI Box is a pre-configured hardware appliance with the full LOGIBLOX platform license pre-installed and ready to run on your premises. It includes the same full feature set as the cloud offering \u2014 data connectors, AI & ML, workflows, app builder \u2014 but operates entirely within your network with no cloud dependency. It's ideal for organisations with strict data residency requirements, regulated industries, or air-gapped environments. The one-time cost is \u20ac39,999 (platform license + hardware). An optional maintenance subscription of \u20ac499/month (or \u20ac4,990/year) covers software updates, remote monitoring, priority support, and training.",
      // CTA section
      cta_title: 'Ready to Transform Your Data Operations?',
      cta_desc: 'Experience the power of a Swiss-engineered AI Operating System. Full-featured platform for analytics, AI, workflows, and REST APIs. Plans start at \u20ac299/month.',
      cta_btn1: 'Request Demo <i class="fe fe-arrow-right ms-2"></i>',
      cta_btn2: 'Talk to Sales',
      cta_note: 'Enterprise-grade platform \u2022 Annual billing \u2022 Flexible evaluation options',
    },

    // ==================== PRODUCT: FLOW (Data Pipelines) ====================
    flow: {
      hero_badge: '<i class="fe fe-git-branch me-2"></i>Data Pipeline Builder',
      hero_title: 'Visual ETL & <span class="text-primary-desat">Workflow Automation</span>',
      hero_desc: 'Build production-ready data pipelines with drag-and-drop. Connect any data source, transform with Python or visual components, and deploy REST APIs in minutes.',
      hero_check1: '<strong>100+ Connectors</strong> - Databases, APIs, IoT protocols, file systems',
      hero_check2: '<strong>Python Extensibility</strong> - Custom scripts with debugging & error handling',
      hero_check3: '<strong>Auto-generated APIs</strong> - REST endpoints with Swagger documentation',
      hero_cta1: 'Start Free Trial <i class="fe fe-arrow-right ms-2"></i>',
      hero_cta2: 'Explore Features',
      overview_title: 'End-to-End Data Pipeline Platform',
      overview_desc: 'From data ingestion to API deployment\u2014everything in one visual environment',
      card1_title: 'Data Integration',
      card1_desc: 'Connect any data source with pre-built connectors or custom integrations. Real-time or batch processing.',
      card1_f1: 'SQL databases (PostgreSQL, MySQL, MSSQL)',
      card1_f2: 'REST APIs & webhooks',
      card1_f3: 'IoT protocols (MQTT, OPC-UA)',
      card1_f4: 'File systems (S3, SFTP, local)',
      card1_f5: 'Spreadsheets (Excel, Google Sheets)',
      card2_title: 'Transform & Process',
      card2_desc: 'Visual data transformation with Python extensibility. AI-assisted cleansing, validation, and schema mapping.',
      card2_f1: 'Drag-and-drop transformations',
      card2_f2: 'Custom Python/SQL scripts',
      card2_f3: 'Data validation & quality rules',
      card2_f4: 'Schema detection & mapping',
      card2_f5: 'Real-time debugging & previews',
      cap_title: 'Pipeline Capabilities',
      cap_desc: 'Production-ready features for data engineers and technical teams',
      cap1_title: 'Version Control',
      cap1_desc: 'Freeze pipeline versions for production. Roll back to any previous state instantly.',
      cap2_title: 'Scheduling & Triggers',
      cap2_desc: 'Cron-based scheduling, event triggers, or API-initiated pipeline runs.',
      cap3_title: 'Error Handling',
      cap3_desc: 'Built-in retry logic, error notifications, and graceful failure recovery.',
      cap4_title: 'REST API Generation',
      cap4_desc: 'Auto-generate REST endpoints with authentication and Swagger docs.',
      cap5_title: 'Test Lab',
      cap5_desc: 'Write test cases for your pipelines and endpoints before deployment.',
      cap6_title: 'Logging & Monitoring',
      cap6_desc: 'Full execution logs, performance metrics, and pipeline run history.',
      usecases_title: 'Pipeline Use Cases',
      videos_title: 'See Pipelines in Action',
      final_title: 'Start Building Data Pipelines',
      final_desc: 'Connect your data sources, build ETL workflows, and deploy REST APIs\u2014all in one platform.',
      final_cta1: 'Start Free Trial <i class="fe fe-arrow-right ms-2"></i>',
      final_cta2: 'View Pricing',
      final_note: '30-day trial \u2022 Self-hosted or cloud \u2022 No vendor lock-in',
    },

    // ==================== PRODUCT: AI ====================
    prod_ai: {
      hero_badge: '<i class="fe fe-zap me-2"></i>AI & Machine Learning Platform',
      hero_title: 'Build AI Solutions <span class="text-primary-desat">Without Code</span>',
      hero_desc: 'From predictive analytics to generative AI\u2014deploy enterprise-grade machine learning models without data science expertise. Swiss-hosted for complete privacy.',
      hero_check1: '<strong>AutoML & Predictive AI</strong> - Train models in minutes',
      hero_check2: '<strong>Generative AI</strong> - Smart Data Transformer for data quality',
      hero_check3: '<strong>Swiss-hosted</strong> - Your data never leaves Switzerland',
      hero_cta1: 'Start Free Trial <i class="fe fe-arrow-right ms-2"></i>',
      hero_cta2: 'Explore Features',
      overview_title: 'Complete AI Platform',
      overview_desc: 'Everything you need to build, deploy, and scale AI solutions\u2014all in one no-code platform',
      card1_title: 'Predictive AI & AutoML',
      card1_desc: 'Build and deploy machine learning models with automated ML workflows. No data science degree required.',
      card1_f1: 'AutoML model training',
      card1_f2: 'Time series forecasting',
      card1_f3: 'Classification & clustering',
      card1_f4: 'Automated feature engineering',
      card1_f5: 'Model deployment & APIs',
      card2_title: 'Generative AI',
      card2_badge: 'Swiss Made',
      card2_desc: 'Smart Data Transformer leverages Gen AI to automatically clean, validate, and enrich your data with Swiss privacy.',
      card2_f1: 'Automated data cleaning',
      card2_f2: 'Intelligent data validation',
      card2_f3: 'Data enrichment & formatting',
      card2_f4: '10x faster data prep',
      card2_f5: 'Swiss-hosted for privacy',
      cap_title: 'Powerful AI Capabilities',
      cap_desc: 'No-code access to enterprise-grade AI and machine learning',
      cap1_title: 'Configure & Train Models',
      cap1_desc: 'Use drag & drop AI to predict and optimize complex data in minutes. No coding required.',
      cap2_title: 'AutoML & Pipelines',
      cap2_desc: 'Save time with LOGIBLOX AutoML building blocks. Adapt, train, validate, and deploy automatically.',
      cap3_title: 'Time Series Forecasting',
      cap3_desc: 'Multivariate AI forecasts with best-in-class algorithms from top-notch data scientists.',
      cap4_title: 'Classification & Clustering',
      cap4_desc: 'Find hidden patterns with pre-built AI models or clustering algorithms for better segmentation.',
      cap5_title: 'Smart Data Transformer',
      cap5_desc: 'Gen AI analytics for instant insights without data science knowledge, plus interpretation.',
      cap6_title: 'Feature Engineering',
      cap6_desc: 'Automated feature engineering selects the right features for your AI models.',
      usecases_title: 'AI Use Cases & Success Stories',
      videos_title: 'See AI in Action',
      final_title: 'Ready to Build AI Solutions?',
      final_desc: 'Start deploying machine learning models with our low-code platform. No data science degree required, no credit card needed for your free trial.',
      final_cta1: 'Start Free Trial <i class="fe fe-arrow-right ms-2"></i>',
      final_cta2: 'View Pricing',
      final_note: '30-day free trial \u2022 Swiss data privacy \u2022 Cancel anytime',
    },

    // ==================== PRODUCT: ANALYTICS ====================
    analytics: {
      hero_badge: '<i class="fe fe-bar-chart-2 me-2"></i>AI & Analytics Platform',
      hero_title: 'Data Analytics & <span class="text-success-desat">AI Models</span>',
      hero_desc: 'From exploratory analysis to production AI models. Time-series forecasting, anomaly detection, clustering, and predictive analytics\u2014all with visual tools or Python.',
      hero_check1: '<strong>Time-Series Forecasting</strong> - Multi-variate predictions with ARIMA, Prophet, LSTM',
      hero_check2: '<strong>Anomaly Detection</strong> - Identify outliers and patterns automatically',
      hero_check3: '<strong>Embedded Analytics</strong> - Deploy as APIs or embed in existing tools',
      hero_cta1: 'Start Free Trial <i class="fe fe-arrow-right ms-2"></i>',
      hero_cta2: 'Explore Features',
      overview_title: 'Analytics & AI Platform',
      overview_desc: 'Statistical analysis, AI models, and visualization\u2014built for data teams',
      card1_title: 'Statistical Analytics',
      card1_desc: 'Exploratory data analysis, statistical tests, and visualization with drag-and-drop or code.',
      card1_f1: 'Descriptive statistics & distributions',
      card1_f2: 'Correlation & regression analysis',
      card1_f3: 'Hypothesis testing',
      card1_f4: 'Time-series decomposition',
      card1_f5: 'Interactive visualizations',
      card2_title: 'AI Models',
      card2_desc: 'Pre-built AI components or custom Python models. AutoML for rapid prototyping.',
      card2_f1: 'Classification & regression',
      card2_f2: 'Clustering & segmentation',
      card2_f3: 'Time-series forecasting',
      card2_f4: 'Anomaly detection',
      card2_f5: 'Model versioning & deployment',
      cap_title: 'Analytics Capabilities',
      cap_desc: 'Visual or code-based analysis for any skill level',
      cap1_title: 'Drag-and-Drop Analysis',
      cap1_desc: 'Visual analytics builder for quick exploratory analysis without writing code.',
      cap2_title: 'Python & R Support',
      cap2_desc: 'Full Python environment with pandas, scikit-learn, TensorFlow, and more.',
      cap3_title: 'AutoML Pipelines',
      cap3_desc: 'Automated feature selection, model training, and hyperparameter tuning.',
      cap4_title: 'Real-Time Scoring',
      cap4_desc: 'Deploy models as REST APIs for real-time predictions in production.',
      cap5_title: 'Embedded Analytics',
      cap5_desc: 'Embed charts, dashboards, or model outputs directly in your applications.',
      cap6_title: 'Scheduled Reports',
      cap6_desc: 'Automated report generation and distribution on custom schedules.',
      usecases_title: 'Analytics Use Cases',
      videos_title: 'See Analytics in Action',
      final_title: 'Start Analyzing Your Data',
      final_desc: 'From exploratory analysis to production AI models\u2014get started in minutes.',
      final_cta1: 'Start Free Trial <i class="fe fe-arrow-right ms-2"></i>',
      final_cta2: 'View Pricing',
      final_note: '30-day trial \u2022 Full Python environment \u2022 No vendor lock-in',
    },

    // ==================== PRODUCT: APP DESIGNER ====================
    appdesigner: {
      hero_badge: '<i class="fe fe-layout me-2"></i>Dashboard & App Builder',
      hero_title: 'Real-Time Dashboards & <span class="text-primary-desat">Data Apps</span>',
      hero_desc: 'Build interactive dashboards and data applications with drag-and-drop. Connect to live data sources, embed in existing tools, or deploy as standalone apps with REST API integration.',
      hero_check1: '<strong>Real-Time Data</strong> - Live connections to databases, APIs, and IoT streams',
      hero_check2: '<strong>Embeddable</strong> - iframe, SDK, or whitelabel deployment options',
      hero_check3: '<strong>Version Control</strong> - Staging environments and rollback capability',
      hero_cta1: 'Start Free Trial <i class="fe fe-arrow-right ms-2"></i>',
      hero_cta2: 'Explore Features',
      overview_title: 'Dashboard & Application Platform',
      overview_desc: 'From simple dashboards to complex data applications\u2014all with visual tools',
      card1_title: 'Real-Time Dashboards',
      card1_desc: 'Interactive visualizations with live data connections. Auto-refresh, alerting, and drill-down capabilities.',
      card1_f1: '30+ chart types & widgets',
      card1_f2: 'Live data connections',
      card1_f3: 'Interactive filters & drill-down',
      card1_f4: 'Scheduled reports & alerts',
      card1_f5: 'Mobile-responsive layouts',
      card2_title: 'Data Applications',
      card2_desc: 'Full CRUD applications with forms, tables, and workflows. Backend logic with visual or Python components.',
      card2_f1: 'Forms with validation',
      card2_f2: 'Data tables with search/filter',
      card2_f3: 'Backend workflow triggers',
      card2_f4: 'Role-based access control',
      card2_f5: 'REST API integration',
      cap_title: 'Builder Capabilities',
      cap_desc: 'Everything you need to build production-ready dashboards and apps',
      cap1_title: 'Drag-and-Drop Builder',
      cap1_desc: 'Visual layout editor with component library. Resize, position, and style without code.',
      cap2_title: 'Templates & Themes',
      cap2_desc: 'Pre-built templates for common use cases. Custom theming and branding options.',
      cap3_title: 'Version Control',
      cap3_desc: 'Save versions, test in staging, and roll back to any previous state.',
      cap4_title: 'Embed & Whitelabel',
      cap4_desc: 'Embed via iframe or SDK. Full whitelabel support for customer-facing deployments.',
      cap5_title: 'Backend Integration',
      cap5_desc: 'Direct connection to pipelines, databases, and REST APIs. Event-driven workflows.',
      cap6_title: 'Access Control',
      cap6_desc: 'Role-based permissions, SSO integration, and audit logging.',
      usecases_title: 'Dashboard & App Use Cases',
      videos_title: 'See the Builder in Action',
      final_title: 'Start Building Dashboards & Apps',
      final_desc: 'From simple dashboards to full data applications\u2014deploy in minutes.',
      final_cta1: 'Start Free Trial <i class="fe fe-arrow-right ms-2"></i>',
      final_cta2: 'View Pricing',
      final_note: '30-day trial \u2022 Embed anywhere \u2022 No vendor lock-in',
    },

    // ==================== TRAINING PAGE ====================
    training: {
      hero_title: 'Your Fun Analytics Training Powerhouse',
      hero_desc: 'Gets you going with the latest and powerful end-to-end no-code analytics capabilities! Logiblox empowers you to realize your dreams & ideas.',
      broaden: 'Broaden your horizon',
      skillset_title: 'Increase your skillset with the vast data transformation & analytics capabilities.',
      skillset_desc: 'The comprehensive LOGIBLOX tools allow you to optimize everyday operations, workflows, processes, improve decision-making and information maturity and enable new business models and services.',
      our_trainings: 'Our Trainings',
      our_trainings_desc: 'Find your no-code analytics training. If you need something more specific, let us customize it to your needs.',
      usecase_collection: 'Use Case Collection',
      usecase_collection_desc: 'Inspiring Use Cases.',
      view_all: 'View all',
      more_title: 'More to find out',
      more_desc: 'Here are a few examples what you can do with LOGIBLOX:',
      regression_title: 'Various Regression Models in minutes',
      regression_desc: "A variable's worth can be predicted using linear regression analysis depending on the value of another parameter. Businesses can use linear regressions to identify trends and generate estimations or forecasts.",
      prediction_title: 'Model training & Predictions',
      prediction_desc: 'Predictive modeling solutions are a type of data-mining technology that examines past and present data and creates a model to assist in making predictions about the future.',
      methods_title: 'Teaching Class Methods:',
      methods_desc: 'Classrooms, webinars, online trainings:',
      classroom_title: 'Class-Room Trainings',
      classroom_desc: 'Attend our class-room trainings in the heart of Zurich and get analytics superpowers delivered face to face.',
      webinars_title: 'Webinars',
      webinars_desc: 'Attend one of our webinars to learn more about no-code, low-code, data automation, analytics, app-building and AI.',
      online_title: 'Online Trainings',
      online_desc: 'Book our online trainings at your own convenience wherever you are. Plus you can make full use of our convenient online-onboarding.',
      get_in_touch: 'Get in Touch',
      newsletter_title: 'Get our latest news delivered',
      newsletter_desc: 'From us to your inbox monthly.',
      email_placeholder: 'Enter your email',
      subscribe: 'Subscribe',
    },

    // ==================== LANGUAGE SWITCHER ====================
    lang: {
      en: 'English',
      de: 'Deutsch',
      current: 'Language',
    },
  },

  de: {
    // ==================== NAVBAR ====================
    nav: {
      platform: 'Plattform',
      solutions: 'Lösungen',
      use_cases: 'Use Cases',
      connectors: 'Connectors',
      pricing: 'Preise',
      resources: 'Ressourcen',
      free_trial: 'Kostenlos testen',
      sign_in: 'Anmelden',
      // Solutions dropdown
      sol_data_eng: 'Data Engineering',
      sol_pipelines: 'Data Pipelines & ETL',
      sol_pipelines_desc: 'Visueller Workflow-Builder mit Python-Support',
      sol_transformer: 'AI Data Transformer',
      sol_transformer_badge: 'Neu',
      sol_transformer_desc: 'Intelligentes Schema-Mapping & Data Cleansing',
      sol_analytics: 'AI & Analytics',
      sol_analytics_desc: 'AutoML, Forecasting & Anomalie-Erkennung',
      sol_dashboards: 'Dashboards & APIs',
      sol_dashboards_desc: 'Echtzeit-Visualisierung & REST-Endpoints',
      sol_platform: 'Plattform',
      sol_connectors: '100+ Connectors',
      sol_connectors_desc: 'Datenbanken, APIs, IoT-Protokolle',
      sol_infra: 'Infrastruktur',
      sol_infra_desc: 'Self-Hosted oder Schweizer Cloud',
      sol_pricing: 'Preise',
      sol_pricing_desc: 'Flexible Pl\u00e4ne f\u00fcr Teams',
      // Resources dropdown
      res_about: '\u00dcber uns',
      res_security: 'Security',
      res_blog: 'Blog',
      res_contact: 'Kontakt',
    },

    // ==================== FOOTER ====================
    footer: {
      tagline: 'Effortless Innovation.',
      copyright: '\u00a9 2026 LOGIBLOX AG. Alle Rechte vorbehalten.',
      overview: '\u00dcBERSICHT',
      why: 'Warum Logiblox?',
      smart_analytics: 'Smart Analytics Plattform',
      capabilities: 'Plattform-Features',
      consulting: 'Data Science & AI Consulting',
      partners: 'Partnerprogramm',
      products: 'PRODUKTE',
      ai_cleanser: 'AI Data Cleanser',
      flow: 'Flow',
      data_analytics: 'Data Analytics',
      app_builder: 'App Builder',
      ai: 'AI',
      pricing_features: 'Pricing & Features',
      solutions_resources: 'SOLUTIONS & RESSOURCEN',
      by_use_case: 'Nach Use Case',
      by_role: 'Nach Rolle / Funktion',
      by_industry: 'Nach Branche',
      data_connectors: 'Data Connectors',
      training: 'Training',
      security: 'Security',
      company_legal: 'Unternehmen & Rechtliches',
      about_us: '\u00dcber uns',
      careers: 'Karriere',
      privacy: 'Datenschutz',
      terms: 'AGB',
      imprint: 'Impressum',
      cookie_text: 'Wir verwenden Cookies, um Ihr Surferlebnis zu verbessern und Ihnen personalisierte Inhalte bereitzustellen.',
      cookie_learn: 'Mehr erfahren',
    },

    // ==================== COMMON / SHARED ====================
    common: {
      learn_more: 'Mehr erfahren',
      read_more: 'Weiterlesen',
      go_back: 'Zur\u00fcck',
      start_free_trial: 'Kostenlos testen',
      view_pricing: 'Pricing ansehen',
      request_demo: 'Demo anfragen',
      book_demo: 'Demo buchen',
      register_free: 'Kostenlos anmelden',
      contact_us: 'Kontakt',
      see_pricing: 'AI Box Pricing',
      order_ai_box: 'AI Box bestellen',
      view_cloud_plans: 'Cloud-Pl\u00e4ne ansehen',
      explore_connectors: 'Connectors entdecken',
      explore_ai: 'AI-Features entdecken',
      explore_analytics: 'Analytics entdecken',
      swiss_made: 'Swiss Made',
      // CTA section
      cta_title: 'Transformieren Sie Ihr Unternehmen',
      cta_text: 'Entdecken Sie verborgene Insights in Ihren Daten und treiben Sie Innovation in Ihrem gesamten Unternehmen voran. Mit den leistungsstarken Tools und intuitiven Oberfl\u00e4chen von LOGIBLOX sch\u00f6pfen Sie das volle Potenzial Ihrer Daten aus.',
      cta_btn: 'Kostenlos testen',
    },

    // ==================== HOME PAGE ====================
    home: {
      // Hero
      hero_badge: 'Jetzt verf\u00fcgbar: LOGIBLOX AI Box',
      hero_title: 'LOGIBLOX AI Box \u2014 <span class="text-primary">On-Premise. Sofort einsatzbereit.</span>',
      hero_lead: 'Die komplette LOGIBLOX AI-Datenplattform auf dedizierter Hardware. Vorinstalliert, vorkonfiguriert \u2014 anschliessen und sofort Data Pipelines bauen, AI-Modelle ausf\u00fchren und Workflows automatisieren. Vollst\u00e4ndig in Ihrem Netzwerk.',
      hero_check1: '<strong>Volle Datenhoheit</strong> \u2014 l\u00e4uft komplett in Ihrem Netzwerk',
      hero_check2: '<strong>Gleicher Feature-Umfang</strong> wie die Cloud \u2014 100+ Connectors, AI, Workflows',
      hero_check3: '<strong>Optionales Wartungs- & Training-Abo</strong> h\u00e4lt Sie aktuell',
      hero_price: 'Ab \u20ac39.999 (Plattform + Hardware) \u00b7 Wartung optional ab \u20ac499/Monat',
      hero_also_cloud: 'Auch als Cloud-Abo verf\u00fcgbar',
      // Proof bar
      proof_1: 'Effizientere Abl\u00e4ufe',
      proof_2: 'Schnellere Entwicklung',
      proof_3: 'Kosteneinsparung vs. Eigenentwicklung',
      // Deployment
      deploy_title: 'W\u00e4hlen Sie Ihr Deployment',
      deploy_subtitle: 'Dieselbe leistungsstarke Plattform. Sie entscheiden, wo sie l\u00e4uft.',
      deploy_box_badge: 'Empfohlen f\u00fcr KMU',
      deploy_box_title: 'LOGIBLOX AI Box',
      deploy_box_type: 'On-Premise Hardware',
      deploy_box_desc: 'Vorkonfigurierte Hardware-Appliance mit kompletter LOGIBLOX-Plattformlizenz, direkt zu Ihnen geliefert. In Ihr Netzwerk einstecken und in Stunden produktiv arbeiten. Keine Cloud-Abh\u00e4ngigkeit, volle Datenhoheit.',
      deploy_box_hw: 'Plattform + Hardware',
      deploy_box_onetime: 'einmalig',
      deploy_box_monthly: 'Optional',
      deploy_box_maint: 'Wartung',
      deploy_box_f1: 'Ihr Netzwerk, Ihre Daten',
      deploy_box_f2: 'Keine Internetabh\u00e4ngigkeit',
      deploy_box_f3: 'Ideal f\u00fcr regulierte Branchen',
      deploy_box_f4: 'Software-Updates & Training optional buchbar',
      deploy_cloud_badge: 'In Minuten starten',
      deploy_cloud_title: 'Cloud Subscription',
      deploy_cloud_type: 'Schweizer Rechenzentren',
      deploy_cloud_desc: 'Gehostet auf Schweizer Infrastruktur. Keine Hardware, keine Wartung \u2014 einfach einloggen und loslegen. DSGVO-konform und produktionsbereit ab Tag eins.',
      deploy_cloud_from: 'Ab',
      deploy_cloud_month: '/Monat',
      deploy_cloud_trial: '30 Tage kostenlos testen',
      deploy_cloud_f1: 'Schweizer Rechenzentren, DSGVO-konform',
      deploy_cloud_f2: 'Keine Hardware oder Wartung',
      deploy_cloud_f3: 'Jederzeit hoch- oder runterskalieren',
      deploy_cloud_f4: '30 Tage Geld-zur\u00fcck-Garantie',
      // Capabilities
      cap_title: 'Alles, was Ihr Data-Team braucht',
      cap_title2: 'in einer Plattform',
      cap_subtitle: 'Verbinden, transformieren, analysieren und automatisieren \u2014 von Rohdaten bis zur Business-Entscheidung.',
      cap_connect_title: 'Jede Datenquelle verbinden',
      cap_connect_desc: '100+ vorgefertigte Connectors f\u00fcr Datenbanken, APIs, IoT-Protokolle (MQTT, OPC-UA), Cloud-Services und Dateisysteme. Erweiterbar mit Python.',
      cap_ai_title: 'AI-gest\u00fctzte Automation',
      cap_ai_desc: 'Smart Data Transformer, AutoML, Time-Series-Forecasting, Anomalie-Erkennung und individuelle AI-Modell-Integration. Von Daten zu Insights \u2014 automatisch.',
      cap_insights_title: 'Insights, Apps & APIs',
      cap_insights_desc: 'Erstellen Sie Echtzeit-Dashboards, interne Business-Apps und REST APIs \u2014 ohne Frontend-Code. Planen Sie Workflows oder triggern Sie sie per Webhook.',
      // Pipeline builder
      pipe_title: 'Visueller <span class="text-primary">Data Pipeline Builder</span>',
      pipe_desc: 'Designen Sie komplexe ETL-Workflows per Drag-and-Drop. Kombinieren Sie visuelle Komponenten mit eigenen Python-Scripts. Debuggen Sie in Echtzeit mit Step-by-Step-Ausf\u00fchrung und Datenvorschau.',
      // Webinars
      webinar_badge: 'Kostenlose Webinare',
      webinar_title: 'Lernen Sie von den Experten',
      webinar_subtitle: 'Nehmen Sie an unseren kostenlosen Live-Webinaren teil und erleben Sie LOGIBLOX in Aktion. Echte Use Cases, Live-Demos und Q&A mit unseren Engineers.',
      webinar_sql_title: 'Text to SQL',
      webinar_sql_desc: 'Querien Sie jede Datenbank in nat\u00fcrlicher Sprache. Sehen Sie, wie AI Business-Fragen in pr\u00e4zises SQL \u00fcbersetzt \u2014 keine SQL-Kenntnisse erforderlich.',
      webinar_auto_title: 'AI-gest\u00fctzte Data Automation',
      webinar_auto_desc: 'Automatisieren Sie Ihre gesamte Data Pipeline mit AI. Von der Datenaufnahme \u00fcber die Transformation bis zu Business Insights \u2014 vollautomatisch und produktionsbereit.',
      webinar_agents_title: 'AI Agents',
      webinar_agents_desc: 'Erstellen Sie intelligente Agents, die Ihre Daten monitoren, automatisierte Actions triggern und autonom Entscheidungen treffen \u2014 die n\u00e4chste Stufe der Data Operations.',
      webinar_more_title: 'Weitere folgen',
      webinar_more_desc: 'IoT Analytics, AutoML in der Praxis, REST APIs ohne Code erstellen und weitere praxisnahe Use Cases.',
      webinar_more_btn: 'Auf dem Laufenden bleiben',
      // Security
      sec_title: 'Produktionsreife Infrastruktur',
      sec_desc: 'Betreiben Sie die Plattform on-premise mit der AI Box oder in Schweizer Rechenzentren. Zuverl\u00e4ssig und mit Enterprise-Security-Standards.',
      sec_f1: 'AI Box On-Premise',
      sec_f2: 'High Availability',
      sec_f3: 'End-to-End Encryption',
      sec_f4: 'DSGVO-konform',
      // Consulting
      consult_title: 'Technischer Implementierungs-Support',
      consult_desc: 'Brauchen Sie Hilfe bei der Architektur Ihrer Dateninfrastruktur? Unser Engineering-Team supportet Sie bei komplexen Integrationen, der Entwicklung individueller Connectors und dem produktiven Deployment.',
      // Final CTA
      final_title: 'Bereit, die Kontrolle \u00fcber Ihre Daten zu \u00fcbernehmen?',
      final_desc: 'Starten Sie mit der AI Box f\u00fcr volle On-Premise-Kontrolle oder gehen Sie in Minuten mit unseren Cloud-Pl\u00e4nen live. In jedem Fall bringt LOGIBLOX Sie ans Ziel.',
      final_price: 'AI Box ab \u20ac39.999 \u00b7 Cloud ab \u20ac299/Monat \u00b7 Swiss Made',
    },

    // ==================== PLATFORM PAGE ====================
    platform: {
      badge: 'All-In-One Plattform',
      hero_title: 'Data Solutions erstellen <span class="text-primary-desat">ohne Code</span>',
      hero_desc: 'Enterprise-Plattform zum Automatisieren von Workflows, Analysieren von Daten, Deployen von AI und Erstellen individueller Apps \u2014 ganz ohne technisches Know-how.',
      hero_f1: '<strong>Kein Coding n\u00f6tig</strong> - In Minuten statt Monaten erstellt',
      hero_f2: '<strong>100+ Integrationen</strong> - Verbinden Sie alle Ihre Datenquellen',
      hero_f3: '<strong>Schweizer Hosting</strong> - Enterprise Security & DSGVO-konform',
      why_title: 'All-in-One Analytics Plattform',
      why_desc: 'LOGIBLOX vereinfacht Ihre Prozesse, indem alles in einer einzigen Plattform integriert wird \u2014 weniger Tools, mehr Konsistenz.',
      why_f1: '<strong>50% Kosteneinsparung</strong> durch Konsolidierung von Tools und bessere Datenkonsistenz',
      why_f2: '<strong>Vollst\u00e4ndige Transparenz</strong> \u00fcber Gesch\u00e4ftsabl\u00e4ufe f\u00fcr schnellere Entscheidungen',
      why_f3: '<strong>Nahtlose Skalierbarkeit</strong> wenn Ihr Unternehmen w\u00e4chst',
      card_automation: 'Automation',
      card_automation_desc: 'Eliminieren Sie manuelle Fehler und vereinfachen Sie Gesch\u00e4ftsprozesse mit modernster Data Automation.',
      card_analytics: 'Analytics',
      card_analytics_desc: 'Daten verarbeiten und analysieren, Insights gewinnen und Entscheidungen optimieren mit Low-Code Analytics.',
      card_app: 'App Builder',
      card_app_desc: 'Erstellen Sie Dashboards und Business-Apps, um Daten zu visualisieren und nahtlos mit Stakeholdern zu kommunizieren.',
      card_ai: 'AI & Analytics',
      card_ai_desc: 'Nutzen Sie AI, um verborgene Insights in Ihren Daten mit pr\u00e4diktiven und generativen AI-Features aufzudecken.',
      nav_lowcode: 'LOW-CODE PLATTFORM',
      nav_predictive: 'PREDICTIVE ANALYTICS',
      nav_automation: 'AUTOMATION',
      nav_business: 'BUSINESS SOLUTIONS',
      nav_ai: 'AI',
      nav_apis: 'APIS & WORKFLOWS',
      nav_dragdrop: 'DRAG & DROP',
      platform_title: 'LOGIBLOX Low-Code Plattform',
      products_title: 'Alles, was Sie brauchen, in einer Plattform',
      products_subtitle: 'Vier leistungsstarke Produkte, die zusammenarbeiten, um Ihre Daten in Actions umzuwandeln',
      view_features: 'Alle Features ansehen',
      // Media sections
      media1_title: 'LOW-CODE PLATTFORM',
      media1_desc: 'Erm\u00f6glichen Sie Ihrem Team, leistungsstarke Analytics-L\u00f6sungen mit minimalem Coding-Aufwand zu erstellen. Unsere Low-Code Plattform macht komplexe Tasks zug\u00e4nglich und bietet technischen Nutzern die Flexibilit\u00e4t zur Anpassung.',
      media2_title: 'PREDICTIVE ANALYTICS',
      media2_desc: 'Gewinnen Sie in Minuten Insights aus komplexen, mehrstufigen Daten. Unsere Plattform erm\u00f6glicht m\u00fchlose Analyse grosser Datasets, nahtlose Zusammenarbeit und schnelle datengest\u00fctzte Entscheidungen.',
      media3_title: 'AUTOMATION',
      media3_desc: 'Nutzen Sie die Kraft der Low-Code Automation, um Data Transformation und Betriebsabl\u00e4ufe zu optimieren. Verwandeln Sie komplexe, verteilte Datasets in verwertbare Insights mit anpassbaren Workflows.',
      media4_title: 'BUSINESS SOLUTIONS',
      media4_desc: 'Entwickeln Sie schnell dynamische Dashboards, Cockpits und andere gesch\u00e4ftskritische L\u00f6sungen. Setzen Sie \u00c4nderungen sofort um, ohne IT-Change-Requests oder Verz\u00f6gerungen.',
      media5_title: 'AI',
      media5_desc: 'Demokratisieren Sie den Zugang zu AI mit Low-Code-L\u00f6sungen, die modernste AI-Technologien, AutoML und Generative AI nutzen. Erstellen Sie fortschrittliche AI-Workflows mit minimalem Coding-Aufwand.',
      media6_title: 'APIS & WORKFLOWS',
      media6_desc: 'Erstellen Sie REST APIs und komplexe Workflows ohne Code. Unsere Microservice-Architektur erm\u00f6glicht die sofortige Erstellung von APIs f\u00fcr die nahtlose Integration aller ben\u00f6tigten Daten.',
      media7_title: 'DRAG & DROP',
      media7_desc: 'Gestalten Sie Workflows und Layouts m\u00fchelos per Drag-and-Drop. Dieser intuitive Ansatz erm\u00f6glicht die Automation von Datenprozessen ohne technisches Know-how oder Coding.',
      // Product cards
      prod_automation_desc: 'LOGIBLOX Automation erledigt das Heavy Lifting f\u00fcr Sie. Verbinden Sie Ihre Datenquelle und automatisieren Sie Data Cleansing und Curation.',
      prod_analytics_desc: 'LOGIBLOX Analytics erm\u00f6glicht Ihnen, Ihre Daten sofort zu analysieren und in Minuten Insights zu gewinnen.',
      prod_ai_desc: 'LOGIBLOX AI ist ein entscheidender Vorteil und verleiht Ihnen Prognose-Superkr\u00e4fte.',
      prod_appbuilder_desc: 'LOGIBLOX App Builder erm\u00f6glicht die sofortige Erstellung dynamischer Dashboards und komplexer Business-Apps.',
      // Final CTA
      final_title: 'Bereit, Ihre Data Operations zu transformieren?',
      final_desc: 'Hunderte Unternehmen nutzen LOGIBLOX zur Automation von Workflows, Gewinnung von Insights und Beschleunigung des Wachstums. Starten Sie noch heute Ihre kostenlose Testversion.',
      final_note: '30 Tage kostenlos \u2022 Keine Kreditkarte erforderlich \u2022 Jederzeit k\u00fcndbar',
    },

    // ==================== CONTACT PAGE ====================
    contact: {
      title: 'Wie k\u00f6nnen wir helfen?',
      subtitle: 'Sagen Sie uns, was Sie suchen \u2014 wir melden uns pers\u00f6nlich innerhalb von 24 Stunden.',
      intent_label: 'Ich m\u00f6chte\u2026',
      demo_title: 'Demo buchen',
      demo_desc: 'Erleben Sie LOGIBLOX in Aktion mit einem unserer Engineers',
      trial_title: 'Cloud testen',
      trial_desc: '30 Tage kostenlos, Schweizer Rechenzentren, keine Karte n\u00f6tig',
      aibox_title: 'AI Box bestellen',
      aibox_desc: 'On-Premise Plattform + Hardware, \u20ac39.999 einmalig',
      question_title: 'Frage stellen',
      question_desc: 'Pricing, Features, Integrationen \u2014 wir helfen gerne',
      next_title: 'Wie geht es weiter',
      step1_title: 'Wir pr\u00fcfen Ihre Anfrage',
      step1_desc: '\u00dcblicherweise innerhalb weniger Stunden an Werktagen',
      step2_title: 'Ein LOGIBLOX-Engineer kontaktiert Sie',
      step2_desc: 'Pers\u00f6nlich \u2014 keine automatisierte Sequenz',
      step3_title: 'Sie sind startklar',
      step3_desc: 'Cloud-Test, Live-Demo oder AI Box-Lieferung \u2014 Ihre Wahl',
      gdpr_note: 'DSGVO-konform \u00b7 End-to-End-verschl\u00fcsselt',
      response_note: 'Antwort innerhalb von 24 Stunden',
      form_title: 'Kontaktieren Sie uns',
      form_subtitle: 'F\u00fcllen Sie Ihre Daten aus und wir melden uns in K\u00fcrze.',
      label_name: 'Name',
      label_email: 'Gesch\u00e4ftliche E-Mail',
      label_company: 'Unternehmen',
      label_phone: 'Telefon (Optional)',
      label_message: 'Nachricht (Optional)',
      placeholder_name: 'Ihr Name',
      placeholder_email: 'sie@unternehmen.com',
      placeholder_company: 'Ihr Unternehmen',
      placeholder_phone: '+41 \u2026',
      placeholder_message: 'Erz\u00e4hlen Sie uns von Ihrem Use Case, Zeitplan oder Fragen\u2026',
      submit: 'Nachricht senden',
      terms_note: 'Mit dem Absenden stimmen Sie unseren',
      terms_link: 'AGB',
      privacy_link: 'Datenschutzrichtlinie',
    },

    // ==================== ABOUT PAGE ====================
    about: {
      mission: 'Unsere Mission',
      mission_desc: 'Bei LOGIBLOX bef\u00e4higen wir Unternehmen mit modernsten AI-L\u00f6sungen, die Effizienz steigern und neue Wachstumsm\u00f6glichkeiten er\u00f6ffnen.',
      what_we_offer: 'Was wir anbieten',
      also_pricing: 'Werfen Sie auch einen Blick auf unser',
      pricing_link: 'Pricing',
      location_title: 'Standort Z\u00fcrich.',
      location_enjoy: 'Geniessen Sie',
      location_desc: 'Wir haben unseren B\u00fcrostandort gew\u00e4hlt, um die Produktivit\u00e4t unseres Teams zu maximieren! Z\u00fcrichs N\u00e4he zu den Alpen mit seiner weiten Natur und zentralen Lage im Herzen Europas, sowie der Zugang zur Weltklasse-ETH Z\u00fcrich & EPFL. Besuchen Sie uns und \u00fcberzeugen Sie sich selbst.',
      stat_quality: 'Schweizer Qualit\u00e4t',
      stat_trains: 'Z\u00fcge p\u00fcnktlich',
      stat_living: 'Lebensqualit\u00e4t',
      join_title: 'Interesse, unserem Team beizutreten?',
      join_desc: 'Kontaktieren Sie uns und wir melden uns bei Ihnen.',
      join_btn: 'Jetzt bewerben',
    },

    // ==================== USE CASES PAGE ====================
    usecases: {
      title: 'LOGIBLOX Use Case Navigator',
      search_placeholder: 'Suchen',
      discover_intro: 'Ich m\u00f6chte mehr erfahren \u00fcber',
      topic: 'Thema',
      all_topics: 'Alle Themen',
      topic_quality: 'Data Quality',
      topic_transformer: 'Data Transformation',
      topic_automation: 'Data Automation',
      topic_ai_apps: 'AI Apps',
      topic_agentic: 'Agentic AI Apps',
      and_or: 'und/oder',
      department: 'Abteilung',
      all_departments: 'Alle Abteilungen',
      dept_finance: 'Buchhaltung, Finanzen & Controlling',
      dept_hr: 'Personal',
      dept_supply: 'Supply Chain, Logistik & Operations',
      dept_marketing: 'Marketing / Vertrieb',
      dept_rnd: 'Forschung und Entwicklung',
      dept_service: 'Kundenservice',
      dept_procurement: 'Einkauf',
      dept_it: 'Digital / IT',
      dept_mgmt: 'Gesch\u00e4ftsleitung',
      discover_suffix: 'M\u00f6glichkeiten mit LOGIBLOX',
      discover_btn: 'Use Cases f\u00fcr Sie entdecken',
      great_examples: 'Hervorragende Use Case Beispiele',
      all_features: 'Alle Produkte & Features',
    },

    // ==================== PRICING PAGE ====================
    pricing: {
      title: 'Einfaches, transparentes <span class="text-primary">Pricing</span>',
      subtitle: 'Zwei M\u00f6glichkeiten, LOGIBLOX zu betreiben \u2014 auf eigener Hardware oder in der Cloud. Dieselbe leistungsstarke Plattform, Ihre Wahl.',
      aibox_btn: 'LOGIBLOX AI Box',
      aibox_badge: 'On-Premise',
      cloud_btn: 'Cloud Subscription',
      trial_badge: '30 Tage kostenlos testen bei allen Cloud-Pl\u00e4nen',
      aibox_btn_html: '<i class="fe fe-cpu me-2"></i>LOGIBLOX AI Box <span class="badge bg-white text-primary ms-2">On-Premise</span>',
      cloud_btn_html: '<i class="fe fe-cloud me-2"></i>Cloud Subscription',
      trial_badge_html: '<i class="fe fe-check me-2"></i>30 Tage kostenlos testen bei allen Cloud-Pl\u00e4nen',
      // Cloud plans section
      cloud_badge: '<i class="fe fe-cloud me-2"></i>Cloud Subscription',
      cloud_title: 'Managed Cloud-Pl\u00e4ne',
      cloud_subtitle: 'Gehostet in Schweizer Rechenzentren. Keine Infrastruktur zu verwalten \u2014 sofort loslegen.',
      // Starter plan
      starter_name: 'Starter',
      starter_price_suffix: '/Monat',
      starter_annual: 'J\u00e4hrliche Abrechnung: \u20ac3.588',
      starter_desc: 'F\u00fcr Teams am Anfang ihrer Datenreise',
      starter_included: 'Enthalten:',
      starter_f1: 'Bis zu 5 Benutzer',
      starter_f2: '10.000 Workflow-Ausf\u00fchrungen/Monat',
      starter_f3: '50 GB Datenspeicher',
      starter_f4: 'Workflow-Automatisierung',
      starter_f5: 'App- & Dashboard-Builder',
      starter_f6: '100+ Data Connectors',
      starter_f7: 'Erweiterte Analysen',
      starter_f8: 'Smart Data Transformer',
      starter_f9: '1.000 AI-Operationen/Monat',
      starter_f10: 'Standard-Support (48h Antwortzeit)',
      starter_btn: 'Kostenlos testen',
      // Professional plan
      pro_badge: 'Beliebteste Wahl',
      pro_name: 'Professional',
      pro_price_suffix: '/Monat',
      pro_annual: 'J\u00e4hrliche Abrechnung: \u20ac10.788',
      pro_desc: 'F\u00fcr wachsende datengetriebene Teams',
      pro_included: 'Starter, plus:',
      pro_workflow_label: 'Workflow-Ausf\u00fchrungen:',
      pro_f1: 'Bis zu 15 Benutzer',
      pro_f2: '200 GB Datenspeicher',
      pro_f3: 'REST API Builder',
      pro_f4: 'Data Quality Manager',
      pro_f5: 'Predictive AI & AutoML',
      pro_f6: '10.000 AI-Operationen/Monat',
      pro_f7: 'Priorisierter Support (24h Antwortzeit)',
      pro_btn: 'Kostenlos testen',
      // Enterprise plan
      ent_badge: 'Bestes Preis-Leistungs-Verh\u00e4ltnis',
      ent_name: 'Enterprise',
      ent_price_suffix: '/Monat',
      ent_annual: 'J\u00e4hrliche Abrechnung: \u20ac35.988',
      ent_desc: 'F\u00fcr unternehmensweite Operationen',
      ent_included: 'Professional, plus:',
      ent_workflow_label: 'Workflow-Ausf\u00fchrungen:',
      ent_f1: 'Bis zu 50 Benutzer',
      ent_f2: '500 GB Datenspeicher',
      ent_f3: 'Data Model Builder',
      ent_f4: '50.000 AI-Operationen/Monat',
      ent_f5: '99,9% Uptime-SLA & Dedicated Support (4h Antwortzeit)',
      ent_btn: 'Kostenlos testen',
      // Enterprise Plus plan
      eplus_name: 'Enterprise Plus',
      eplus_price: 'Individuell',
      eplus_tailored: 'Massgeschneidert f\u00fcr Ihre Anforderungen',
      eplus_desc: 'F\u00fcr gesch\u00e4ftskritische Deployments',
      eplus_included: 'Enterprise, plus:',
      eplus_f1: 'Unbegrenzte Benutzer',
      eplus_f2: 'Unbegrenzte Workflow-Ausf\u00fchrungen',
      eplus_f3: 'Individueller Datenspeicher',
      eplus_f4: 'Individuelle Integrationen',
      eplus_f5: 'Unbegrenzte AI-Aufrufe',
      eplus_f6: 'On-Premise Deployment',
      eplus_f7: '24/7 Dedicated Support',
      eplus_f8: '99,99% Uptime-SLA',
      eplus_f9: 'Account Manager',
      eplus_f10: 'White Label / Custom Branding',
      eplus_btn: 'Vertrieb kontaktieren',
      // Compare plans
      compare_title: 'Pl\u00e4ne vergleichen',
      compare_subtitle: 'Detaillierter Feature-Vergleich f\u00fcr die richtige Planwahl',
      compare_feature: 'Feature',
      compare_col_foundation: 'Foundation<br><small class="fw-normal text-muted">\u20ac299/Mo.</small>',
      compare_col_pro: 'Professional<br><small class="fw-normal text-muted">ab \u20ac899/Mo.</small>',
      compare_col_ent: 'Enterprise<br><small class="fw-normal text-muted">ab \u20ac2.999/Mo.</small>',
      compare_col_eplus: 'Enterprise Plus<br><small class="fw-normal text-muted">Individuell</small>',
      // Table section headers
      tbl_sec_core: 'Plattform-Limits',
      tbl_sec_automation: 'Automation & Workflows',
      tbl_sec_connectivity: 'Data Connectivity',
      tbl_sec_analytics: 'Analytics & Insights',
      tbl_sec_appbuilder: 'App Builder',
      tbl_sec_apis: 'APIs & Integration',
      tbl_sec_ai: 'AI & Machine Learning',
      tbl_sec_enterprise: 'Enterprise-Features',
      tbl_sec_support: 'Support & SLA',
      // Table row headers
      tbl_users: 'Benutzer',
      tbl_workflow_runs: 'Workflow-Ausf\u00fchrungen/Monat',
      tbl_data_storage: 'Datenspeicher',
      tbl_apps_dashboards: 'Apps & Dashboards',
      tbl_ai_ops: 'AI-Operationen/Monat',
      tbl_workflow_automation: 'Workflow-Automatisierung',
      tbl_drag_drop_workflow: 'Drag & Drop Workflow Builder',
      tbl_data_transformation: 'Data Transformation',
      tbl_scheduled_workflows: 'Geplante Workflows',
      tbl_prebuilt_connectors: '100+ vorgefertigte Connectors',
      tbl_db_connectors: 'Datenbank-Connectors (SQL, NoSQL)',
      tbl_cloud_services: 'Cloud Services (AWS, Azure, GCP)',
      tbl_custom_connectors: 'Individuelle Connectors',
      tbl_basic_analytics: 'Basis-Analytics',
      tbl_advanced_analytics: 'Erweiterte Analytics',
      tbl_custom_dashboards: 'Individuelle Dashboards',
      tbl_data_viz: 'Datenvisualisierung',
      tbl_drag_drop_app: 'Drag & Drop App Builder',
      tbl_business_apps: 'Business Apps & Formulare',
      tbl_white_labeling: 'White Labeling',
      tbl_rest_api: 'REST API Builder',
      tbl_api_mgmt: 'API Management',
      tbl_webhooks: 'Webhooks',
      tbl_smart_transformer: 'Smart Data Transformer (Gen AI)',
      tbl_ai_cleaning: 'AI Data Cleaning & Validierung',
      tbl_predictive_ai: 'Predictive AI & AutoML',
      tbl_timeseries: 'Time Series Forecasting',
      tbl_classification: 'Klassifizierung & Clustering',
      tbl_feature_eng: 'Automatisiertes Feature Engineering',
      tbl_custom_integrations: 'Individuelle Integrationen & Entwicklung',
      tbl_onpremise: 'On-Premise Deployment',
      tbl_dedicated_infra: 'Dedizierte Infrastruktur',
      tbl_support_type: 'Support-Typ',
      tbl_response_time: 'Antwortzeit',
      tbl_uptime_sla: 'Uptime-SLA',
      tbl_training: 'Training & Onboarding',
      // Table cell values
      tbl_up_to_5: 'Bis zu 5',
      tbl_up_to_15: 'Bis zu 15',
      tbl_up_to_50: 'Bis zu 50',
      tbl_unlimited: 'Unbegrenzt',
      tbl_custom: 'Individuell',
      tbl_basic: 'Basis',
      tbl_email: 'E-Mail',
      tbl_priority_email: 'Priorisierte E-Mail',
      tbl_priority_live: 'Priorit\u00e4t + Live-Chat',
      tbl_dedicated_247: '24/7 Dedicated',
      tbl_48h: '48 Stunden',
      tbl_24h: '24 Stunden',
      tbl_4h: '4 Stunden',
      tbl_1h: '1 Stunde',
      tbl_docs: 'Dokumentation',
      tbl_video_tutorials: 'Video-Tutorials',
      tbl_live_training: 'Live-Training',
      tbl_dedicated_onboarding: 'Dediziertes Onboarding',
      // Guarantee & custom
      guarantee_title: '30 Tage Geld-zur\u00fcck-Garantie',
      guarantee_desc: 'Testen Sie jeden kostenpflichtigen Plan risikofrei. Wenn Sie innerhalb von 30 Tagen nicht zufrieden sind, erhalten Sie eine vollst\u00e4ndige R\u00fcckerstattung \u2014 ohne R\u00fcckfragen.',
      custom_title: 'Individuelle Enterprise-L\u00f6sungen',
      custom_desc: 'Sie ben\u00f6tigen etwas Spezielles? Wir bieten massgeschneiderte L\u00f6sungen mit individuellen Features, Integrationen und Deployment-Optionen, die genau auf Ihre Anforderungen zugeschnitten sind.',
      // AI Box section
      box_badge: '<i class="fe fe-cpu me-2"></i>On-Premise Hardware',
      box_title: 'LOGIBLOX AI Box',
      box_subtitle: 'Die komplette LOGIBLOX-Plattform auf dedizierter Hardware. Anschliessen, verbinden und loslegen \u2014 volle Datenhoheit, keine Cloud-Abh\u00e4ngigkeit.',
      box_hw_title: 'AI Box Hardware',
      box_hw_type: 'Einmalkauf',
      box_hw_price_desc: 'Einmalig \u2014 inklusive vollst\u00e4ndiger LOGIBLOX-Plattformlizenz, Hardware, Vorinstallation &amp; Ersteinrichtung',
      box_hw_included: 'Was in der Box enthalten ist:',
      box_hw_f1: 'Dedizierte On-Premise Hardware-Appliance',
      box_hw_f2: 'LOGIBLOX vorinstalliert &amp; vorkonfiguriert',
      box_hw_f3: 'Vollst\u00e4ndiger Plattform-Funktionsumfang (wie Cloud)',
      box_hw_f4: '100+ Data Connectors',
      box_hw_f5: 'AI- &amp; ML-Funktionen',
      box_hw_f6: 'Visueller Workflow Builder &amp; App Designer',
      box_hw_f7: 'Vor-Ort-Installation &amp; Erstkonfiguration',
      box_hw_btn: 'AI Box bestellen <i class="fe fe-arrow-right ms-2"></i>',
      box_maint_addon: 'Optionales Add-on',
      box_maint_title: 'Wartung &amp; Training',
      box_maint_type: 'Optional \u2014 empfohlen',
      box_maint_monthly: '/Monat',
      box_maint_annual: 'J\u00e4hrliche Abrechnung: <strong>\u20ac4.990/Jahr</strong> <span class="badge bg-success-soft text-success ms-1">~17% sparen</span>',
      box_maint_desc: 'Halten Sie Ihre AI Box aktuell und vollst\u00e4ndig unterst\u00fctzt',
      box_maint_included: 'Monatlich enthalten:',
      box_maint_f1: 'Software-Updates &amp; Sicherheits-Patches',
      box_maint_f2: 'Remote-Monitoring &amp; Health Checks',
      box_maint_f3: 'Priorisierter Support (24h Antwortzeit)',
      box_maint_f4: 'Training-Credits (2 Sessions/Jahr inklusive)',
      box_maint_f5: 'Connector- &amp; Feature-Updates',
      box_maint_f6: 'Hardware-Garantie &amp; Austausch-Abdeckung',
      box_maint_f7: 'Zugang zu neuen AI-Modulen bei Verf\u00fcgbarkeit',
      box_maint_btn: 'Vertrieb kontaktieren',
      box_vs_cloud_title: 'AI Box vs. Cloud Subscription',
      box_vs_cloud_desc: 'Beide Angebote umfassen den gleichen vollst\u00e4ndigen LOGIBLOX-Plattform-Funktionsumfang. W\u00e4hlen Sie die Cloud f\u00fcr Flexibilit\u00e4t und null Infrastruktur-Aufwand. W\u00e4hlen Sie die AI Box f\u00fcr volle On-Premise-Kontrolle und Datenhoheit \u2014 ideal f\u00fcr regulierte Branchen, Air-Gapped-Umgebungen oder Organisationen mit strengen Anforderungen an die Datenresidenz. Das Wartungs-Abo ist optional, wird aber empfohlen, um Ihr System aktuell zu halten.',
      // FAQ section
      faq_title: 'H\u00e4ufig gestellte Fragen',
      faq_subtitle: 'Wichtige Fragen zu LOGIBLOX Pricing und Pl\u00e4nen',
      faq1_q: 'Was passiert, wenn ich meine Plan-Limits \u00fcberschreite?',
      faq1_a: 'Wir benachrichtigen Sie, wenn Sie sich Ihren Limits n\u00e4hern. Sie k\u00f6nnen jederzeit auf einen h\u00f6heren Tarif upgraden, wobei die Kosten anteilig berechnet werden. Ihre Workflows werden nicht gestoppt \u2014 wir finden gemeinsam die richtige L\u00f6sung.',
      faq2_q: 'Kann ich meinen Plan jederzeit wechseln?',
      faq2_a: 'Ja! Sie k\u00f6nnen Ihren Plan jederzeit upgraden oder downgraden. Beim Upgrade erhalten Sie eine anteilige Gutschrift f\u00fcr Ihren aktuellen Plan. Downgrades werden zu Beginn des n\u00e4chsten Abrechnungszyklus wirksam.',
      faq3_q: 'Wie funktioniert die 30-t\u00e4gige kostenlose Testphase?',
      faq3_a: 'Kontaktieren Sie unser Vertriebsteam, um eine individuelle Testphase zu besprechen, die auf die Bed\u00fcrfnisse Ihrer Organisation zugeschnitten ist. Wir bieten flexible Evaluierungsoptionen, um sicherzustellen, dass LOGIBLOX die richtige L\u00f6sung f\u00fcr Ihre Datenoperationen ist.',
      faq4_q: 'Welche Zahlungsmethoden akzeptieren Sie?',
      faq4_a: 'Wir akzeptieren alle g\u00e4ngigen Kreditkarten (Visa, MasterCard, American Express), Bank\u00fcberweisungen f\u00fcr Jahrespl\u00e4ne und k\u00f6nnen Rechnungsstellung f\u00fcr Enterprise-Kunden arrangieren.',
      faq5_q: 'Bieten Sie Rabatte f\u00fcr j\u00e4hrliche Abrechnung?',
      faq5_a: 'J\u00e4hrliche Abrechnung ist unser Standard-Preismodell. Foundation: \u20ac3.588/Jahr, Professional: ab \u20ac10.788/Jahr, Enterprise: ab \u20ac35.988/Jahr. Monatliche Abrechnung ist auf Anfrage verf\u00fcgbar. Kontaktieren Sie unser Vertriebsteam f\u00fcr individuelle Enterprise Plus Preise.',
      faq6_q: 'Was sind AI-Aufrufe und wie werden sie verwendet?',
      faq6_a: 'AI-Operationen treiben intelligente Features wie Smart Data Transformer (generative AI f\u00fcr Data Cleaning), Predictive Analytics, AutoML-Modelltraining, Time Series Forecasting und automatisierte Datenvalidierung an. Jede AI-Operation (Transformation, Vorhersage oder Modelltraining) z\u00e4hlt als eine Operation. Verschiedene Pl\u00e4ne beinhalten unterschiedliche monatliche Kontingente: Starter (1.000), Professional (10.000), Enterprise (50.000) und Enterprise Plus (unbegrenzt).',
      faq7_q: 'Welche Art von Support ist enthalten?',
      faq7_a: 'Starter umfasst E-Mail-Support (48h Antwortzeit). Professional bietet zus\u00e4tzlich priorisierten E-Mail-Support (24h Antwortzeit) und Video-Tutorials. Business umfasst priorisierten Support mit Live-Chat (4h Antwortzeit) und Live-Training. Enterprise erh\u00e4lt 24/7 Dedicated Support (1h Antwortzeit), dediziertes Onboarding und einen pers\u00f6nlichen Account Manager.',
      faq8_q: 'Was ist die LOGIBLOX AI Box und wie unterscheidet sie sich von der Cloud?',
      faq8_a: 'Die LOGIBLOX AI Box ist eine vorkonfigurierte Hardware-Appliance mit der vollst\u00e4ndigen LOGIBLOX-Plattformlizenz, vorinstalliert und bereit zur Nutzung in Ihrem Unternehmen. Sie bietet den gleichen vollst\u00e4ndigen Funktionsumfang wie die Cloud \u2014 Data Connectors, AI & ML, Workflows, App Builder \u2014 l\u00e4uft aber vollst\u00e4ndig in Ihrem Netzwerk ohne Cloud-Abh\u00e4ngigkeit. Ideal f\u00fcr Organisationen mit strengen Anforderungen an die Datenresidenz, regulierte Branchen oder Air-Gapped-Umgebungen. Die Einmalkosten betragen \u20ac39.999 (Plattformlizenz + Hardware). Ein optionales Wartungs-Abo von \u20ac499/Monat (oder \u20ac4.990/Jahr) umfasst Software-Updates, Remote-Monitoring, priorisierten Support und Training.',
      // CTA section
      cta_title: 'Bereit, Ihre Datenoperationen zu transformieren?',
      cta_desc: 'Erleben Sie die Leistungsf\u00e4higkeit eines in der Schweiz entwickelten AI Operating Systems. Vollst\u00e4ndige Plattform f\u00fcr Analytics, AI, Workflows und REST APIs. Pl\u00e4ne ab \u20ac299/Monat.',
      cta_btn1: 'Demo anfragen <i class="fe fe-arrow-right ms-2"></i>',
      cta_btn2: 'Vertrieb kontaktieren',
      cta_note: 'Enterprise-Plattform \u2022 J\u00e4hrliche Abrechnung \u2022 Flexible Evaluierungsoptionen',
    },

    // ==================== PRODUCT: FLOW (Data Pipelines) ====================
    flow: {
      hero_badge: '<i class="fe fe-git-branch me-2"></i>Data Pipeline Builder',
      hero_title: 'Visuelles ETL & <span class="text-primary-desat">Workflow-Automation</span>',
      hero_desc: 'Erstellen Sie produktionsreife Data Pipelines per Drag-and-Drop. Verbinden Sie jede Datenquelle, transformieren Sie mit Python oder visuellen Komponenten und deployen Sie REST APIs in Minuten.',
      hero_check1: '<strong>100+ Connectors</strong> - Datenbanken, APIs, IoT-Protokolle, Dateisysteme',
      hero_check2: '<strong>Python-Erweiterbarkeit</strong> - Eigene Scripts mit Debugging & Error Handling',
      hero_check3: '<strong>Auto-generierte APIs</strong> - REST-Endpoints mit Swagger-Dokumentation',
      hero_cta1: 'Kostenlos testen <i class="fe fe-arrow-right ms-2"></i>',
      hero_cta2: 'Features entdecken',
      overview_title: 'End-to-End Data Pipeline Plattform',
      overview_desc: 'Von der Datenaufnahme bis zum API-Deployment \u2014 alles in einer visuellen Umgebung',
      card1_title: 'Data Integration',
      card1_desc: 'Verbinden Sie jede Datenquelle mit vorgefertigten Connectors oder individuellen Integrationen. Echtzeit- oder Batch-Verarbeitung.',
      card1_f1: 'SQL-Datenbanken (PostgreSQL, MySQL, MSSQL)',
      card1_f2: 'REST APIs & Webhooks',
      card1_f3: 'IoT-Protokolle (MQTT, OPC-UA)',
      card1_f4: 'Dateisysteme (S3, SFTP, lokal)',
      card1_f5: 'Tabellenkalkulationen (Excel, Google Sheets)',
      card2_title: 'Transformieren & Verarbeiten',
      card2_desc: 'Visuelle Datentransformation mit Python-Erweiterbarkeit. AI-gest\u00fctzte Bereinigung, Validierung und Schema-Mapping.',
      card2_f1: 'Drag-and-Drop-Transformationen',
      card2_f2: 'Eigene Python-/SQL-Scripts',
      card2_f3: 'Datenvalidierung & Qualit\u00e4tsregeln',
      card2_f4: 'Schema-Erkennung & -Mapping',
      card2_f5: 'Echtzeit-Debugging & Vorschauen',
      cap_title: 'Pipeline-Features',
      cap_desc: 'Produktionsreife Features f\u00fcr Data Engineers und technische Teams',
      cap1_title: 'Versionskontrolle',
      cap1_desc: 'Pipeline-Versionen f\u00fcr die Produktion einfrieren. Jederzeit sofort auf fr\u00fchere Versionen zur\u00fcckrollen.',
      cap2_title: 'Scheduling & Trigger',
      cap2_desc: 'Cron-basiertes Scheduling, Event-Trigger oder API-initiierte Pipeline-Ausf\u00fchrungen.',
      cap3_title: 'Error Handling',
      cap3_desc: 'Integrierte Retry-Logik, Fehlerbenachrichtigungen und kontrollierte Fehlerbehandlung.',
      cap4_title: 'REST API Generierung',
      cap4_desc: 'REST-Endpoints automatisch generieren mit Authentifizierung und Swagger-Docs.',
      cap5_title: 'Test Lab',
      cap5_desc: 'Testf\u00e4lle f\u00fcr Ihre Pipelines und Endpoints vor dem Deployment schreiben.',
      cap6_title: 'Logging & Monitoring',
      cap6_desc: 'Vollst\u00e4ndige Ausf\u00fchrungslogs, Performance-Metriken und Pipeline-Verlauf.',
      usecases_title: 'Pipeline Use Cases',
      videos_title: 'Pipelines in Aktion',
      final_title: 'Starten Sie mit Data Pipelines',
      final_desc: 'Verbinden Sie Ihre Datenquellen, erstellen Sie ETL-Workflows und deployen Sie REST APIs \u2014 alles in einer Plattform.',
      final_cta1: 'Kostenlos testen <i class="fe fe-arrow-right ms-2"></i>',
      final_cta2: 'Pricing ansehen',
      final_note: '30 Tage testen \u2022 Self-Hosted oder Cloud \u2022 Kein Vendor Lock-in',
    },

    // ==================== PRODUCT: AI ====================
    prod_ai: {
      hero_badge: '<i class="fe fe-zap me-2"></i>AI & Machine Learning Plattform',
      hero_title: 'AI-L\u00f6sungen erstellen <span class="text-primary-desat">ohne Code</span>',
      hero_desc: 'Von Predictive Analytics bis Generative AI \u2014 deployen Sie Enterprise-Machine-Learning-Modelle ohne Data-Science-Expertise. Schweizer Hosting f\u00fcr vollst\u00e4ndigen Datenschutz.',
      hero_check1: '<strong>AutoML & Predictive AI</strong> - Modelle in Minuten trainieren',
      hero_check2: '<strong>Generative AI</strong> - Smart Data Transformer f\u00fcr Data Quality',
      hero_check3: '<strong>Schweizer Hosting</strong> - Ihre Daten verlassen die Schweiz nicht',
      hero_cta1: 'Kostenlos testen <i class="fe fe-arrow-right ms-2"></i>',
      hero_cta2: 'Features entdecken',
      overview_title: 'Komplette AI-Plattform',
      overview_desc: 'Alles, was Sie brauchen, um AI-L\u00f6sungen zu erstellen, zu deployen und zu skalieren \u2014 in einer No-Code-Plattform',
      card1_title: 'Predictive AI & AutoML',
      card1_desc: 'Machine-Learning-Modelle erstellen und deployen mit automatisierten ML-Workflows. Kein Data-Science-Studium erforderlich.',
      card1_f1: 'AutoML-Modelltraining',
      card1_f2: 'Time Series Forecasting',
      card1_f3: 'Klassifizierung & Clustering',
      card1_f4: 'Automatisiertes Feature Engineering',
      card1_f5: 'Model Deployment & APIs',
      card2_title: 'Generative AI',
      card2_badge: 'Swiss Made',
      card2_desc: 'Der Smart Data Transformer nutzt Gen AI, um Ihre Daten automatisch zu bereinigen, zu validieren und anzureichern \u2014 mit Schweizer Datenschutz.',
      card2_f1: 'Automatisierte Datenbereinigung',
      card2_f2: 'Intelligente Datenvalidierung',
      card2_f3: 'Datenanreicherung & Formatierung',
      card2_f4: '10x schnellere Datenaufbereitung',
      card2_f5: 'Schweizer Hosting f\u00fcr Datenschutz',
      cap_title: 'Leistungsstarke AI-Features',
      cap_desc: 'No-Code-Zugang zu Enterprise-AI und Machine Learning',
      cap1_title: 'Modelle konfigurieren & trainieren',
      cap1_desc: 'Nutzen Sie Drag & Drop AI, um komplexe Daten in Minuten vorherzusagen und zu optimieren. Kein Coding erforderlich.',
      cap2_title: 'AutoML & Pipelines',
      cap2_desc: 'Sparen Sie Zeit mit LOGIBLOX AutoML-Bausteinen. Automatisch anpassen, trainieren, validieren und deployen.',
      cap3_title: 'Time Series Forecasting',
      cap3_desc: 'Multivariate AI-Prognosen mit erstklassigen Algorithmen von Top-Data-Scientists.',
      cap4_title: 'Klassifizierung & Clustering',
      cap4_desc: 'Verborgene Muster finden mit vorgefertigten AI-Modellen oder Clustering-Algorithmen f\u00fcr bessere Segmentierung.',
      cap5_title: 'Smart Data Transformer',
      cap5_desc: 'Gen AI Analytics f\u00fcr sofortige Insights ohne Data-Science-Kenntnisse, plus Interpretation.',
      cap6_title: 'Feature Engineering',
      cap6_desc: 'Automatisiertes Feature Engineering w\u00e4hlt die richtigen Features f\u00fcr Ihre AI-Modelle aus.',
      usecases_title: 'AI Use Cases & Erfolgsgeschichten',
      videos_title: 'AI in Aktion',
      final_title: 'Bereit, AI-L\u00f6sungen zu erstellen?',
      final_desc: 'Deployen Sie Machine-Learning-Modelle mit unserer Low-Code-Plattform. Kein Data-Science-Studium erforderlich, keine Kreditkarte f\u00fcr Ihre kostenlose Testphase.',
      final_cta1: 'Kostenlos testen <i class="fe fe-arrow-right ms-2"></i>',
      final_cta2: 'Pricing ansehen',
      final_note: '30 Tage kostenlos \u2022 Schweizer Datenschutz \u2022 Jederzeit k\u00fcndbar',
    },

    // ==================== PRODUCT: ANALYTICS ====================
    analytics: {
      hero_badge: '<i class="fe fe-bar-chart-2 me-2"></i>AI & Analytics Plattform',
      hero_title: 'Data Analytics & <span class="text-success-desat">AI-Modelle</span>',
      hero_desc: 'Von explorativer Analyse bis zu produktiven AI-Modellen. Time-Series-Forecasting, Anomalie-Erkennung, Clustering und Predictive Analytics \u2014 mit visuellen Tools oder Python.',
      hero_check1: '<strong>Time-Series-Forecasting</strong> - Multivariate Prognosen mit ARIMA, Prophet, LSTM',
      hero_check2: '<strong>Anomalie-Erkennung</strong> - Ausreisser und Muster automatisch identifizieren',
      hero_check3: '<strong>Embedded Analytics</strong> - Als APIs deployen oder in bestehende Tools einbetten',
      hero_cta1: 'Kostenlos testen <i class="fe fe-arrow-right ms-2"></i>',
      hero_cta2: 'Features entdecken',
      overview_title: 'Analytics & AI Plattform',
      overview_desc: 'Statistische Analysen, AI-Modelle und Visualisierung \u2014 entwickelt f\u00fcr Data-Teams',
      card1_title: 'Statistische Analysen',
      card1_desc: 'Explorative Datenanalyse, statistische Tests und Visualisierung per Drag-and-Drop oder Code.',
      card1_f1: 'Deskriptive Statistik & Verteilungen',
      card1_f2: 'Korrelations- & Regressionsanalyse',
      card1_f3: 'Hypothesentests',
      card1_f4: 'Time-Series-Dekomposition',
      card1_f5: 'Interaktive Visualisierungen',
      card2_title: 'AI-Modelle',
      card2_desc: 'Vorgefertigte AI-Komponenten oder eigene Python-Modelle. AutoML f\u00fcr schnelles Prototyping.',
      card2_f1: 'Klassifizierung & Regression',
      card2_f2: 'Clustering & Segmentierung',
      card2_f3: 'Time-Series-Forecasting',
      card2_f4: 'Anomalie-Erkennung',
      card2_f5: 'Modell-Versionierung & Deployment',
      cap_title: 'Analytics-Features',
      cap_desc: 'Visuelle oder codebasierte Analyse f\u00fcr jedes Kompetenzniveau',
      cap1_title: 'Drag-and-Drop-Analyse',
      cap1_desc: 'Visueller Analytics Builder f\u00fcr schnelle explorative Analysen ohne Code.',
      cap2_title: 'Python- & R-Support',
      cap2_desc: 'Vollst\u00e4ndige Python-Umgebung mit pandas, scikit-learn, TensorFlow und mehr.',
      cap3_title: 'AutoML Pipelines',
      cap3_desc: 'Automatisierte Feature-Auswahl, Modelltraining und Hyperparameter-Tuning.',
      cap4_title: 'Echtzeit-Scoring',
      cap4_desc: 'Modelle als REST APIs f\u00fcr Echtzeit-Vorhersagen in der Produktion deployen.',
      cap5_title: 'Embedded Analytics',
      cap5_desc: 'Charts, Dashboards oder Modell-Outputs direkt in Ihre Anwendungen einbetten.',
      cap6_title: 'Geplante Reports',
      cap6_desc: 'Automatisierte Report-Erstellung und -Verteilung nach individuellen Zeitpl\u00e4nen.',
      usecases_title: 'Analytics Use Cases',
      videos_title: 'Analytics in Aktion',
      final_title: 'Starten Sie mit der Datenanalyse',
      final_desc: 'Von explorativer Analyse bis zu produktiven AI-Modellen \u2014 in Minuten loslegen.',
      final_cta1: 'Kostenlos testen <i class="fe fe-arrow-right ms-2"></i>',
      final_cta2: 'Pricing ansehen',
      final_note: '30 Tage testen \u2022 Vollst\u00e4ndige Python-Umgebung \u2022 Kein Vendor Lock-in',
    },

    // ==================== PRODUCT: APP DESIGNER ====================
    appdesigner: {
      hero_badge: '<i class="fe fe-layout me-2"></i>Dashboard & App Builder',
      hero_title: 'Echtzeit-Dashboards & <span class="text-primary-desat">Data Apps</span>',
      hero_desc: 'Erstellen Sie interaktive Dashboards und Datenanwendungen per Drag-and-Drop. Verbinden Sie Live-Datenquellen, betten Sie in bestehende Tools ein oder deployen Sie als eigenst\u00e4ndige Apps mit REST API Integration.',
      hero_check1: '<strong>Echtzeit-Daten</strong> - Live-Verbindungen zu Datenbanken, APIs und IoT-Streams',
      hero_check2: '<strong>Einbettbar</strong> - iframe, SDK oder Whitelabel-Deployment-Optionen',
      hero_check3: '<strong>Versionskontrolle</strong> - Staging-Umgebungen und Rollback-F\u00e4higkeit',
      hero_cta1: 'Kostenlos testen <i class="fe fe-arrow-right ms-2"></i>',
      hero_cta2: 'Features entdecken',
      overview_title: 'Dashboard & Application Plattform',
      overview_desc: 'Von einfachen Dashboards bis zu komplexen Datenanwendungen \u2014 alles mit visuellen Tools',
      card1_title: 'Echtzeit-Dashboards',
      card1_desc: 'Interaktive Visualisierungen mit Live-Datenverbindungen. Auto-Refresh, Alerting und Drill-Down-Funktionen.',
      card1_f1: '30+ Diagrammtypen & Widgets',
      card1_f2: 'Live-Datenverbindungen',
      card1_f3: 'Interaktive Filter & Drill-Down',
      card1_f4: 'Geplante Reports & Alerts',
      card1_f5: 'Mobile-responsive Layouts',
      card2_title: 'Datenanwendungen',
      card2_desc: 'Vollst\u00e4ndige CRUD-Anwendungen mit Formularen, Tabellen und Workflows. Backend-Logik mit visuellen oder Python-Komponenten.',
      card2_f1: 'Formulare mit Validierung',
      card2_f2: 'Datentabellen mit Suche/Filter',
      card2_f3: 'Backend-Workflow-Trigger',
      card2_f4: 'Rollenbasierte Zugriffskontrolle',
      card2_f5: 'REST API Integration',
      cap_title: 'Builder-Features',
      cap_desc: 'Alles, was Sie f\u00fcr produktionsreife Dashboards und Apps ben\u00f6tigen',
      cap1_title: 'Drag-and-Drop Builder',
      cap1_desc: 'Visueller Layout-Editor mit Komponentenbibliothek. Gr\u00f6sse, Position und Styling ohne Code anpassen.',
      cap2_title: 'Templates & Themes',
      cap2_desc: 'Vorgefertigte Templates f\u00fcr g\u00e4ngige Use Cases. Individuelle Themes und Branding-Optionen.',
      cap3_title: 'Versionskontrolle',
      cap3_desc: 'Versionen speichern, in Staging testen und jederzeit auf fr\u00fchere Versionen zur\u00fcckrollen.',
      cap4_title: 'Einbetten & Whitelabel',
      cap4_desc: 'Einbetten per iframe oder SDK. Vollst\u00e4ndiger Whitelabel-Support f\u00fcr kundenorientierte Deployments.',
      cap5_title: 'Backend-Integration',
      cap5_desc: 'Direkte Verbindung zu Pipelines, Datenbanken und REST APIs. Event-getriebene Workflows.',
      cap6_title: 'Zugriffskontrolle',
      cap6_desc: 'Rollenbasierte Berechtigungen, SSO-Integration und Audit-Logging.',
      usecases_title: 'Dashboard & App Use Cases',
      videos_title: 'Den Builder in Aktion erleben',
      final_title: 'Starten Sie mit Dashboards & Apps',
      final_desc: 'Von einfachen Dashboards bis zu vollst\u00e4ndigen Datenanwendungen \u2014 in Minuten deployen.',
      final_cta1: 'Kostenlos testen <i class="fe fe-arrow-right ms-2"></i>',
      final_cta2: 'Pricing ansehen',
      final_note: '30 Tage testen \u2022 \u00dcberall einbetten \u2022 Kein Vendor Lock-in',
    },

    // ==================== TRAINING PAGE ====================
    training: {
      hero_title: 'Ihr Analytics Training Powerhouse',
      hero_desc: 'Starten Sie durch mit den neuesten und leistungsstarken End-to-End No-Code Analytics-Funktionen! Logiblox erm\u00f6glicht es Ihnen, Ihre Ideen und Visionen zu verwirklichen.',
      broaden: 'Erweitern Sie Ihren Horizont',
      skillset_title: 'Erweitern Sie Ihre F\u00e4higkeiten mit den umfangreichen Data Transformation & Analytics-Funktionen.',
      skillset_desc: 'Die umfassenden LOGIBLOX-Tools erm\u00f6glichen es Ihnen, allt\u00e4gliche Abl\u00e4ufe, Workflows und Prozesse zu optimieren, Entscheidungsfindung und Informationsreife zu verbessern sowie neue Gesch\u00e4ftsmodelle und Services zu erm\u00f6glichen.',
      our_trainings: 'Unsere Trainings',
      our_trainings_desc: 'Finden Sie Ihr No-Code Analytics Training. Wenn Sie etwas Spezifischeres ben\u00f6tigen, passen wir es gerne an Ihre Anforderungen an.',
      usecase_collection: 'Use Case Sammlung',
      usecase_collection_desc: 'Inspirierende Use Cases.',
      view_all: 'Alle anzeigen',
      more_title: 'Mehr entdecken',
      more_desc: 'Hier sind einige Beispiele, was Sie mit LOGIBLOX erreichen k\u00f6nnen:',
      regression_title: 'Verschiedene Regressionsmodelle in Minuten',
      regression_desc: 'Der Wert einer Variablen kann mittels linearer Regressionsanalyse in Abh\u00e4ngigkeit vom Wert eines anderen Parameters vorhergesagt werden. Unternehmen k\u00f6nnen lineare Regressionen nutzen, um Trends zu identifizieren und Sch\u00e4tzungen oder Prognosen zu erstellen.',
      prediction_title: 'Modelltraining & Vorhersagen',
      prediction_desc: 'Predictive-Modeling-L\u00f6sungen sind eine Art Data-Mining-Technologie, die vergangene und aktuelle Daten untersucht und ein Modell erstellt, das bei Vorhersagen \u00fcber die Zukunft hilft.',
      methods_title: 'Unterrichtsmethoden:',
      methods_desc: 'Pr\u00e4senztrainings, Webinare, Online-Trainings:',
      classroom_title: 'Pr\u00e4senztrainings',
      classroom_desc: 'Besuchen Sie unsere Pr\u00e4senztrainings im Herzen von Z\u00fcrich und erhalten Sie Analytics-Superkr\u00e4fte von Angesicht zu Angesicht.',
      webinars_title: 'Webinare',
      webinars_desc: 'Nehmen Sie an einem unserer Webinare teil, um mehr \u00fcber No-Code, Low-Code, Data Automation, Analytics, App-Building und AI zu erfahren.',
      online_title: 'Online-Trainings',
      online_desc: 'Buchen Sie unsere Online-Trainings ganz nach Ihrem Zeitplan, wo auch immer Sie sind. Nutzen Sie ausserdem unser komfortables Online-Onboarding.',
      get_in_touch: 'Kontaktieren Sie uns',
      newsletter_title: 'Unsere neuesten Nachrichten erhalten',
      newsletter_desc: 'Von uns in Ihren Posteingang \u2014 monatlich.',
      email_placeholder: 'Ihre E-Mail-Adresse',
      subscribe: 'Abonnieren',
    },

    // ==================== LANGUAGE SWITCHER ====================
    lang: {
      en: 'English',
      de: 'Deutsch',
      current: 'Sprache',
    },
  },
};
